import {Injectable} from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
//Services
import { CommonService } from './common.service';
import { UtilService } from './util.service'
//Rxjs imports
import {Observable} from 'rxjs';
// Data Model
import { CouponModel, IConfigObj } from '../models/data.model';
import { defer, of, throwError, catchError, map, Subject } from 'rxjs';
import { EnviormentConfig } from '../wcax-env-config';
import { UserInfoService } from './user-info.service';
import { AemService } from './aem.service';

declare let $: any;

@Injectable({
  providedIn: 'root'
})
export class J4uV1Service {
    private config = EnviormentConfig;
    public currentEnv = '';
    private GALLERY_API = '';
    private SUBSCRIPTION_API = '';
    private HTTP_OPTIONS = {};
    private p13nApi = window['SWY']['CONFIGSERVICE']?.wcaxXapiConfig ? window.location.origin + window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['p13n.loyaltyCarousel.basePath'] : '';
    private additionalCouponsAmount: number = 10;
    private objCoupons = {};
    private instantEventName = window['AB']['COMMON'].getURLParameterByName("eventName");
    private instantEventDateTime = window['AB']['COMMON'].getURLParameterByName("eventDateTime");
    private instantCorrelationId = window['AB']['COMMON'].getURLParameterByName("eventCorrelationId");
    public isDataCached = false;
    public rewardProtoTypes = ['REWARDS_FLAT', 'REWARDS_ACCUMULATION'];
    public instantAllocationReqBody = {};
    private defaultModUnitImage = {
        src: null,
        alt: null,
        openNewTab: null,
        dataSrc: null,
        target: null
    }
    private isBonusPathPage: boolean = false;
    private _companionGalleryOfferPOST = new Subject<CouponModel[]>();
    public listenCompanionGalleryOfferPOST$ = this._companionGalleryOfferPOST.asObservable();
    public onCouponsAndDealsPageReload: boolean = false;
    // TODO: REMOVE WHEN WE NO LONGER NEED TO USE MOCK DATA
    private isMockP13nCarouselDataEnabled = false; 
    private additionalResponseCount = 0;
    private mockInitialResponse = [
        {
            "offerId": "44770823",
            "categoryType": "Wine, Beer & Spirits",
            "category": "Wine, Beer & Spirits",
            "clipTs": "1705950273756",
            "description": "Postman $0.66 when you buy 1 Postman Any variety.",
            "startDate": "1645988400000",
            "endDate": "1735585200000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/20f7e4d5-08e7-4714-886b-779cd6464eb3.gif",
            "limits": "O",
            "name": "ALEN Pinalen",
            "brand": "ALEN Pinalen",
            "offerPgm": "MF",
            "offerPrice": "$0.96 OFF",
            "offerSubPgm": "09",
            "offerTs": "1668557706000",
            "purchaseInd": "L",
            "purchaseRank": "39",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "39",
            "expiryRank": "39",
            "companionOfferIds": [],
            "disclaimer": "Test Legal stuff goes here",
            "deleted": true,
            "imageId": "20f7e4d5-08e7-4714-886b-779cd6464eb3",
            "extlOfferId": "22238-27024-20",
            "hierarchies": {
                "categories": [
                    "Wine, Beer & Spirits"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "48407035",
            "categoryType": "Personal Care & Health",
            "category": "Personal Care & Health",
            "clipTs": "1705950245604",
            "description": "$3.00 OFF when you buy TWO(2) Gillette Razor/Blade Refill Valid on Gillette Razor OR Blade Refill 4 ct or larger. Items must appear on the same receipt.",
            "startDate": "1685728800000",
            "endDate": "1717178400000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/d2c4d7b1-1cda-4c8b-870a-015d2eaf26f4.gif",
            "limits": "O",
            "name": "Gillete",
            "brand": "Gillete",
            "offerPgm": "MF",
            "offerPrice": "$3.00 OFF",
            "offerSubPgm": "09",
            "offerTs": "1687542958000",
            "offerProgramType": "MUST_BUY",
            "offerProtoType": "MUST_BUY",
            "purchaseInd": "L",
            "purchaseRank": "48",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "48",
            "expiryRank": "48",
            "companionOfferIds": [],
            "disclaimer": "Legal Description",
            "deleted": true,
            "imageId": "d2c4d7b1-1cda-4c8b-870a-015d2eaf26f4",
            "extlOfferId": "00123-47400-19",
            "hierarchies": {
                "categories": [
                    "Personal Care & Health"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "49237635",
            "categoryType": "Dairy, Eggs & Cheese",
            "category": "Dairy, Eggs & Cheese",
            "clipTs": "1705950329002",
            "description": "P13N-BIA",
            "startDate": "1679940000000",
            "endDate": "1711908000000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
            "limits": "O",
            "name": "Buy 1 Get 1",
            "brand": "Buy 1 Get 1",
            "offerPgm": "SC",
            "offerPrice": "Buy 1 Get 1",
            "offerSubPgm": "02",
            "offerTs": "1679958107000",
            "offerProgramType": "BUYX_GETX",
            "offerProtoType": "BUYX_GETX",
            "purchaseInd": "L",
            "purchaseRank": "18",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "18",
            "expiryRank": "18",
            "companionOfferIds": [],
            "deleted": true,
            "imageId": "2",
            "extlOfferId": "49237635-D",
            "hierarchies": {
                "categories": [
                    "Dairy, Eggs & Cheese",
                    "Frozen Foods"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "50043380",
            "categoryType": "Beverages",
            "category": "Beverages",
            "clipTs": "1705950312700",
            "description": "Free Pepsi Drink when you buy THREE(3) Pepsi Drink Any variety. Items must appear on the same receipt.",
            "startDate": "1646161200000",
            "endDate": "1714500000000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
            "limits": "O",
            "name": "Pepsi",
            "brand": "Pepsi",
            "offerPgm": "MF",
            "offerPrice": "Free Pepsi Drink",
            "offerSubPgm": "09",
            "offerTs": "1656499966000",
            "purchaseInd": "L",
            "purchaseRank": "22",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "22",
            "expiryRank": "22",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
            "deleted": true,
            "imageId": "Pepsi",
            "extlOfferId": "00219-23322-03",
            "hierarchies": {
                "categories": [
                    "Beverages"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "50043586",
            "categoryType": "Cookies, Snacks & Candy",
            "category": "Cookies, Snacks & Candy",
            "clipTs": "1705950277345",
            "description": "Free Tostitos Salsa when you buy ONE(1) Tostitos Chips Any variety.",
            "startDate": "1654106400000",
            "endDate": "1714500000000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/20f7e4d5-08e7-4714-886b-779cd6464eb3.gif",
            "limits": "O",
            "name": "Tostitos",
            "brand": "Tostitos",
            "offerPgm": "MF",
            "offerPrice": "Free Tostitos Salsa",
            "offerSubPgm": "09",
            "offerTs": "1658934698000",
            "purchaseInd": "L",
            "purchaseRank": "35",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "35",
            "expiryRank": "35",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
            "deleted": true,
            "imageId": "20f7e4d5-08e7-4714-886b-779cd6464eb3",
            "extlOfferId": "00219-23222-01",
            "hierarchies": {
                "categories": [
                    "Cookies, Snacks & Candy"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "50044189",
            "categoryType": "Beverages",
            "category": "Beverages",
            "clipTs": "1705950311494",
            "description": "Free Pepsi Drink when you buy THREE(3) Pepsi Drink Any variety. Items must appear on the same receipt.",
            "startDate": "1646161200000",
            "endDate": "1714500000000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
            "limits": "O",
            "name": "Pepsi",
            "brand": "Pepsi",
            "offerPgm": "MF",
            "offerPrice": "Free Pepsi Drink",
            "offerSubPgm": "09",
            "offerTs": "1656500085000",
            "purchaseInd": "L",
            "purchaseRank": "23",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "23",
            "expiryRank": "23",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
            "deleted": true,
            "imageId": "Pepsi",
            "extlOfferId": "00219-23322-00",
            "hierarchies": {
                "categories": [
                    "Beverages"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "50044195",
            "categoryType": "Beverages",
            "category": "Beverages",
            "clipTs": "1705950306020",
            "description": "Free Pepsi Drink when you buy THREE(3) Pepsi Drink Any variety. Items must appear on the same receipt.",
            "startDate": "1646161200000",
            "endDate": "1714500000000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
            "limits": "O",
            "name": "Pepsi",
            "brand": "Pepsi",
            "offerPgm": "MF",
            "offerPrice": "Free Pepsi Drink",
            "offerSubPgm": "09",
            "offerTs": "1656500214000",
            "purchaseInd": "L",
            "purchaseRank": "24",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "24",
            "expiryRank": "24",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
            "deleted": true,
            "imageId": "Pepsi",
            "extlOfferId": "00219-23322-05",
            "hierarchies": {
                "categories": [
                    "Beverages"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "50044386",
            "categoryType": "Beverages",
            "category": "Beverages",
            "clipTs": "1705950304944",
            "description": "Free Pepsi Drink when you buy THREE(3) Pepsi Drink Any variety. Items must appear on the same receipt.",
            "startDate": "1646161200000",
            "endDate": "1714500000000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
            "limits": "O",
            "name": "Pepsi",
            "brand": "Pepsi",
            "offerPgm": "MF",
            "offerPrice": "Free Pepsi Drink",
            "offerSubPgm": "09",
            "offerTs": "1656500117000",
            "purchaseInd": "L",
            "purchaseRank": "25",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "25",
            "expiryRank": "25",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
            "deleted": true,
            "imageId": "Pepsi",
            "extlOfferId": "00219-23322-06",
            "hierarchies": {
                "categories": [
                    "Beverages"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "54078384",
            "categoryType": "Wine, Beer & Spirits",
            "category": "Wine, Beer & Spirits",
            "clipTs": "1705950272166",
            "description": "Postman 22 $0.66 when you buy 1 Postman Any variety.",
            "startDate": "1645988400000",
            "endDate": "1735585200000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/20f7e4d5-08e7-4714-886b-779cd6464eb3.gif",
            "limits": "O",
            "name": "ALEN Pinalen",
            "brand": "ALEN Pinalen",
            "offerPgm": "MF",
            "offerPrice": "$0.96 OFF",
            "offerSubPgm": "09",
            "offerTs": "1669295601000",
            "purchaseInd": "L",
            "purchaseRank": "40",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "40",
            "expiryRank": "40",
            "companionOfferIds": [],
            "disclaimer": "Test Legal stuff goes here",
            "deleted": true,
            "imageId": "20f7e4d5-08e7-4714-886b-779cd6464eb3",
            "extlOfferId": "22238-27024-23",
            "hierarchies": {
                "categories": [
                    "Wine, Beer & Spirits"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "54682067",
            "categoryType": "Wine, Beer & Spirits",
            "category": "Wine, Beer & Spirits",
            "clipTs": "1705950263927",
            "description": "Test Cancel $2.59 OFF Huggies Baby Wipes 1X when you buy ONE(1) Huggies Little Movers or Little Snugglers Diapers Valid on Giga Pack (44 - 72 ct.).",
            "startDate": "1670007600000",
            "endDate": "1717178400000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/a8daa138-26e6-4d17-a054-0220a8892bce.gif",
            "limits": "O",
            "name": "Huggies",
            "brand": "Huggies",
            "offerPgm": "MF",
            "offerPrice": "$2.59 OFF Huggies Baby Wipes 1X",
            "offerSubPgm": "09",
            "offerTs": "1688756795000",
            "offerProgramType": "BUYX_GETY",
            "offerProtoType": "BUYX_GETY",
            "purchaseInd": "L",
            "purchaseRank": "44",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "44",
            "expiryRank": "44",
            "companionOfferIds": [],
            "disclaimer": "Reproduction, alteration, proliferation, or sale of this coupon or its contents is strictly prohibited. Civil and criminal penalties up to $2,000,000 and/or imprisonment may apply. CONSUMER: LIMIT ONE (1) COUPON PER PURCHASE on product/quantity specified. Only 1 coupon per product purchased CANNOT BE COMBINED with any other coupon. Any other use constitutes fraud. VOID IF COPIED, SCANNED, TRANSFERRED, MODIFIED, AUCTIONED, PURCHASED OR SOLD. No cash or credit in excess of shelf price after discounts may be returned to consumer or applied to the transaction. CIC® Member Coupon Integrity Program. RETAILER: K-C will reimburse you the face value of this coupon plus $.08 handling if submitted in compliance with our Coupon Redemption Policy. Mail coupons or requests for Policy to: Kimberly-Clark 1112, P.O. Box 880001, El Paso, TX 88588-0001. Void where prohibited or restricted. Cash value 1/100 cent. Valid only in the USA, its Territories and Possessions. ® Registered Trademark and TM Trademark of Kimberly-Clark Worldwide, Inc. © KCWW.",
            "deleted": true,
            "imageId": "a8daa138-26e6-4d17-a054-0220a8892bce",
            "extlOfferId": "17546-201072-15",
            "hierarchies": {
                "categories": [
                    "Wine, Beer & Spirits"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "56869509",
            "categoryType": "Cookies, Snacks & Candy",
            "category": "Cookies, Snacks & Candy",
            "clipTs": "1705950276480",
            "description": "Free Tostitos Salsa when you buy ONE(1) Tostitos Chips Any variety.",
            "startDate": "1654106400000",
            "endDate": "1714500000000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/90174cad-c248-452d-9b8a-63e44af82962.gif",
            "limits": "O",
            "name": "Tostitos",
            "brand": "Tostitos",
            "offerPgm": "MF",
            "offerPrice": "Free Tostitos Salsa",
            "offerSubPgm": "09",
            "offerTs": "1662509989000",
            "purchaseInd": "L",
            "purchaseRank": "36",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "36",
            "expiryRank": "36",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
            "deleted": true,
            "imageId": "90174cad-c248-452d-9b8a-63e44af82962",
            "extlOfferId": "00219-23222-02",
            "hierarchies": {
                "categories": [
                    "Cookies, Snacks & Candy"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "57365527",
            "categoryType": "International Cuisine",
            "category": "International Cuisine",
            "clipTs": "1705950281885",
            "description": "Free New Pepsi when you buy TWO(2) New Pepsi Any variety. Items must appear on the same receipt.",
            "startDate": "1669662000000",
            "endDate": "1732820400000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
            "limits": "O",
            "name": "Pepsi",
            "brand": "Pepsi",
            "offerPgm": "MF",
            "offerPrice": "Free New Pepsi",
            "offerSubPgm": "09",
            "offerTs": "1670260206000",
            "purchaseInd": "L",
            "purchaseRank": "30",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "30",
            "expiryRank": "30",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: LIMIT ONE (1) COUPON PER PURCHASE OF PRODUCT & QUANTITY STATED. No more than two (2) identical coupons for same product in same day. Do not send this coupon to ColgatePalmolive. Void if transferred, sold, auctioned, reproduced or altered from original. You must pay any sales tax. RETAILER: ColgatePalmolive will reimburse the face value plus up to 10.5¢ handling if submitted in accordance with our Redemption Policy. For policy and/or coupon redemption send to: Colgate-Palmolive 1119, P.O. Box 880001, El Paso, TX 88588-0001. Cash Value 1/100¢. No cash or credit in excess of shelf price may be returned to consumer or applied to transaction. Coupon may not be bought, reproduced, transferred or sold. Void where prohibited or if transferred to any person, firm or group prior to store redemption. Valid only in the USA (not in Puerto Rico). Redeemable at Food, Drug, Discount & other stores accepting coupons. Colgate-Palmolive participates in the CIC® member Coupon Integrity Program.",
            "deleted": true,
            "imageId": "Pepsi",
            "extlOfferId": "00123-053715-58",
            "hierarchies": {
                "categories": [
                    "International Cuisine"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "59458603",
            "categoryType": "Cookies, Snacks & Candy",
            "category": "Cookies, Snacks & Candy",
            "clipTs": "1705950275595",
            "description": "$1.00 OFF when you buy ONE(1) Tostitos Chips Any variety.",
            "startDate": "1646161200000",
            "endDate": "1714500000000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/chipsSalsa.gif",
            "limits": "O",
            "name": "Tostitos",
            "brand": "Tostitos",
            "offerPgm": "MF",
            "offerPrice": "$1.00 OFF",
            "offerSubPgm": "09",
            "offerTs": "1656500010000",
            "purchaseInd": "L",
            "purchaseRank": "37",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "37",
            "expiryRank": "37",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
            "deleted": true,
            "imageId": "chipsSalsa",
            "extlOfferId": "00219-22222-00",
            "hierarchies": {
                "categories": [
                    "Cookies, Snacks & Candy"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "60709623",
            "categoryType": "Paper, Cleaning & Home",
            "category": "Paper, Cleaning & Home",
            "clipTs": "1705950283697",
            "description": "$ 1.00 OFF - When Buy 2 Limit 1 / P13N -SPA-DFTA - Offer-Test",
            "startDate": "1696010400000",
            "endDate": "1719770400000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
            "limits": "U",
            "name": "$ 1.00 OFF",
            "brand": "$ 1.00 OFF",
            "offerPgm": "SC",
            "offerPrice": "$1.00 OFF",
            "offerSubPgm": "02",
            "offerTs": "1696010497324",
            "offerProgramType": "ITEM_DISCOUNT",
            "offerProtoType": "ITEM_DISCOUNT",
            "purchaseInd": "L",
            "purchaseRank": "28",
            "status": "C",
            "usageType": "U",
            "arrivalRank": "28",
            "expiryRank": "28",
            "companionOfferIds": [],
            "disclaimer": "$ 1.00 OFF - When Buy 2 Limit 1 / P13N -SPA-DFTA - Offer-Test",
            "deleted": true,
            "imageId": "2",
            "extlOfferId": "60709623-D",
            "hierarchies": {
                "categories": [
                    "Paper, Cleaning & Home"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "60844906",
            "categoryType": "Baby Care",
            "category": "Baby Care",
            "clipTs": "1705950354722",
            "description": "Offer Request Test Automation NIA",
            "startDate": "1703098800000",
            "endDate": "1736449200000",
            "events": [
                "Weekly Ad Coupons"
            ],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
            "limits": "O",
            "name": "OMS Offer Request test Automation HeadLine NIA",
            "brand": "OMS Offer Request test Automation HeadLine NIA",
            "offerPgm": "SC",
            "offerPrice": "$15 Savings Value",
            "offerSubPgm": "02",
            "offerTs": "1703112972578",
            "offerProgramType": "BUYX_GETY",
            "offerProtoType": "BUYX_GETY",
            "purchaseInd": "L",
            "purchaseRank": "14",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "14",
            "expiryRank": "14",
            "companionOfferIds": [],
            "disclaimer": "Save $A when you spend $X, or Save $B when you spend $Y, or Save $C when you spend $Z or more in qualifying purchases in a single transaction using your just for U account ($X or $Y or $Z minimum purchase calculated after deduction of promotional and loyalty card savings, coupons and all other discounts, offers and savings). Offer is valid [INSERT START DATE] - [INSERT END DATE] only at participating Safeway and Albertsons stores located in Colorado, Nebraska, South Dakota, Eastern Wyoming, Farmington, NM and Aztec, NM. Qualifying purchases exclude: alcoholic beverages, tobacco products, fluid dairy, fuel, prescription items and co-payments, fishing/hunting licenses and tags, postage stamps, money orders/transfers, bus/commuter passes, amusement park/ski/event/lottery tickets, phone cards, gift cards/certificates and applicable taxes, bottle/container deposits and bag fees.",
            "deleted": true,
            "imageId": "9",
            "extlOfferId": "60844906-D",
            "hierarchies": {
                "categories": [
                    "Baby Care"
                ],
                "events": [
                    "Weekly Ad Coupons"
                ]
            },
            "etag": "default"
        },
        {
            "offerId": "63129370",
            "categoryType": "Frozen Foods",
            "category": "Frozen Foods",
            "clipTs": "1705950346983",
            "description": "BIA on sale Item discount",
            "startDate": "1687543200000",
            "endDate": "1711735200000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
            "limits": "U",
            "name": "BIA on Sale",
            "brand": "BIA on Sale",
            "offerPgm": "SC",
            "offerPrice": "$0.49 Off",
            "offerSubPgm": "02",
            "offerTs": "1687557995000",
            "offerProgramType": "ITEM_DISCOUNT",
            "offerProtoType": "ITEM_DISCOUNT",
            "purchaseInd": "L",
            "purchaseRank": "17",
            "status": "C",
            "usageType": "U",
            "arrivalRank": "17",
            "expiryRank": "17",
            "companionOfferIds": [],
            "deleted": true,
            "imageId": "2",
            "extlOfferId": "63129370-D",
            "hierarchies": {
                "categories": [
                    "Frozen Foods"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "70502927",
            "categoryType": "Beverages",
            "category": "Beverages",
            "clipTs": "1706550940988",
            "description": "Free Pepsi Drink when you buy ONE(1) Pepsi Drink Any variety.",
            "startDate": "1646161200000",
            "endDate": "1714500000000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
            "limits": "O",
            "name": "Pepsi",
            "brand": "Pepsi",
            "offerPgm": "MF",
            "offerPrice": "Free Pepsi Drink",
            "offerSubPgm": "09",
            "offerTs": "1656500035000",
            "purchaseInd": "L",
            "purchaseRank": "8",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "8",
            "expiryRank": "8",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
            "deleted": true,
            "imageId": "Pepsi",
            "extlOfferId": "00219-221212-01",
            "hierarchies": {
                "categories": [
                    "Beverages"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "72715826",
            "categoryType": "Fruits & Vegetables",
            "category": "Fruits & Vegetables",
            "clipTs": "1705950279918",
            "description": "flkds",
            "startDate": "1704913200000",
            "endDate": "1746468000000",
            "events": [
                "$5 Friday"
            ],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/7.gif",
            "limits": "U",
            "name": "fljksd",
            "brand": "fljksd",
            "offerPgm": "SC",
            "offerPrice": "fsdlk",
            "offerSubPgm": "02",
            "offerTs": "1702969593129",
            "offerProgramType": "REWARDS_ACCUMULATION",
            "offerProtoType": "REWARDS_ACCUMULATION",
            "purchaseInd": "L",
            "purchaseRank": "32",
            "status": "C",
            "usageType": "U",
            "arrivalRank": "32",
            "expiryRank": "32",
            "companionOfferIds": [],
            "disclaimer": "fljksd",
            "deleted": true,
            "imageId": "7",
            "extlOfferId": "72715826-D",
            "hierarchies": {
                "categories": [
                    "Fruits & Vegetables"
                ],
                "events": [
                    "$5 Friday"
                ]
            },
            "etag": "default"
        },
        {
            "offerId": "79319623",
            "categoryType": "Cookies, Snacks & Candy",
            "category": "Cookies, Snacks & Candy",
            "clipTs": "1705950274681",
            "description": "Free Tostitos Salsa when you buy ONE(1) Tostitos Chips Any variety.",
            "startDate": "1654106400000",
            "endDate": "1714500000000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/90174cad-c248-452d-9b8a-63e44af82962.gif",
            "limits": "O",
            "name": "Tostitos",
            "brand": "Tostitos",
            "offerPgm": "MF",
            "offerPrice": "Free Tostitos Salsa",
            "offerSubPgm": "09",
            "offerTs": "1663064210000",
            "purchaseInd": "L",
            "purchaseRank": "38",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "38",
            "expiryRank": "38",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
            "deleted": true,
            "imageId": "90174cad-c248-452d-9b8a-63e44af82962",
            "extlOfferId": "00219-23222-04",
            "hierarchies": {
                "categories": [
                    "Cookies, Snacks & Candy"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "80127773",
            "categoryType": "Cookies, Snacks & Candy",
            "category": "Cookies, Snacks & Candy",
            "clipTs": "1706550930444",
            "description": "Free Tostitos Salsa when you buy ONE(1) Tostitos Chips Any variety.",
            "startDate": "1654106400000",
            "endDate": "1714500000000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/90174cad-c248-452d-9b8a-63e44af82962.gif",
            "limits": "O",
            "name": "Tostitos",
            "brand": "Tostitos",
            "offerPgm": "MF",
            "offerPrice": "Free Tostitos Salsa",
            "offerSubPgm": "09",
            "offerTs": "1665522449000",
            "purchaseInd": "L",
            "purchaseRank": "9",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "9",
            "expiryRank": "9",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
            "deleted": true,
            "imageId": "90174cad-c248-452d-9b8a-63e44af82962",
            "extlOfferId": "00219-23222-05",
            "hierarchies": {
                "categories": [
                    "Cookies, Snacks & Candy"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "80849349",
            "categoryType": "Baby Care",
            "category": "Baby Care",
            "clipTs": "1705950352691",
            "description": "erums nonhealth1",
            "startDate": "1703098800000",
            "endDate": "1767726000000",
            "events": [
                "Weekly Ad Coupons"
            ],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
            "limits": "O",
            "name": "erums nonhealth1",
            "brand": "erums nonhealth1",
            "offerPgm": "SC",
            "offerPrice": "$15 Savings Value",
            "offerSubPgm": "02",
            "offerTs": "1703117130219",
            "offerProgramType": "BUYX_GETY",
            "offerProtoType": "BUYX_GETY",
            "purchaseInd": "L",
            "purchaseRank": "15",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "15",
            "expiryRank": "15",
            "companionOfferIds": [],
            "disclaimer": "Save $A when you spend $X, or Save $B when you spend $Y, or Save $C when you spend $Z or more in qualifying purchases in a single transaction using your just for U account ($X or $Y or $Z minimum purchase calculated after deduction of promotional and loyalty card savings, coupons and all other discounts, offers and savings). Offer is valid [INSERT START DATE] - [INSERT END DATE] only at participating Safeway and Albertsons stores located in Colorado, Nebraska, South Dakota, Eastern Wyoming, Farmington, NM and Aztec, NM. Qualifying purchases exclude: alcoholic beverages, tobacco products, fluid dairy, fuel, prescription items and co-payments, fishing/hunting licenses and tags, postage stamps, money orders/transfers, bus/commuter passes, amusement park/ski/event/lottery tickets, phone cards, gift cards/certificates and applicable taxes, bottle/container deposits and bag fees.",
            "deleted": true,
            "imageId": "9",
            "extlOfferId": "80849349-D",
            "hierarchies": {
                "categories": [
                    "Baby Care"
                ],
                "events": [
                    "Weekly Ad Coupons"
                ]
            },
            "etag": "default"
        },
        {
            "offerId": "81912468",
            "categoryType": "Baby Care",
            "category": "Baby Care",
            "clipTs": "1705950364905",
            "description": "erums nonhealth4",
            "startDate": "1703098800000",
            "endDate": "1720116000000",
            "events": [
                "Weekly Ad Coupons"
            ],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
            "limits": "O",
            "name": "erums nonhealth4",
            "brand": "erums nonhealth4",
            "offerPgm": "SC",
            "offerPrice": "$15 Savings Value",
            "offerSubPgm": "02",
            "offerTs": "1703116991471",
            "offerProgramType": "BUYX_GETY",
            "offerProtoType": "BUYX_GETY",
            "purchaseInd": "L",
            "purchaseRank": "11",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "11",
            "expiryRank": "11",
            "companionOfferIds": [],
            "disclaimer": "Save $A when you spend $X, or Save $B when you spend $Y, or Save $C when you spend $Z or more in qualifying purchases in a single transaction using your just for U account ($X or $Y or $Z minimum purchase calculated after deduction of promotional and loyalty card savings, coupons and all other discounts, offers and savings). Offer is valid [INSERT START DATE] - [INSERT END DATE] only at participating Safeway and Albertsons stores located in Colorado, Nebraska, South Dakota, Eastern Wyoming, Farmington, NM and Aztec, NM. Qualifying purchases exclude: alcoholic beverages, tobacco products, fluid dairy, fuel, prescription items and co-payments, fishing/hunting licenses and tags, postage stamps, money orders/transfers, bus/commuter passes, amusement park/ski/event/lottery tickets, phone cards, gift cards/certificates and applicable taxes, bottle/container deposits and bag fees.",
            "deleted": true,
            "imageId": "9",
            "extlOfferId": "81912468-D",
            "hierarchies": {
                "categories": [
                    "Baby Care"
                ],
                "events": [
                    "Weekly Ad Coupons"
                ]
            },
            "etag": "default"
        },
        {
            "offerId": "82302573",
            "categoryType": "Baby Care",
            "category": "Baby Care",
            "clipTs": "1705950365920",
            "description": "erums nonhealth2",
            "startDate": "1703098800000",
            "endDate": "1726164000000",
            "events": [
                "Weekly Ad Coupons"
            ],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
            "limits": "O",
            "name": "erums nonhealth2",
            "brand": "erums nonhealth2",
            "offerPgm": "SC",
            "offerPrice": "$15 Savings Value",
            "offerSubPgm": "02",
            "offerTs": "1703117091589",
            "offerProgramType": "BUYX_GETY",
            "offerProtoType": "BUYX_GETY",
            "purchaseInd": "L",
            "purchaseRank": "10",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "10",
            "expiryRank": "10",
            "companionOfferIds": [],
            "disclaimer": "Save $A when you spend $X, or Save $B when you spend $Y, or Save $C when you spend $Z or more in qualifying purchases in a single transaction using your just for U account ($X or $Y or $Z minimum purchase calculated after deduction of promotional and loyalty card savings, coupons and all other discounts, offers and savings). Offer is valid [INSERT START DATE] - [INSERT END DATE] only at participating Safeway and Albertsons stores located in Colorado, Nebraska, South Dakota, Eastern Wyoming, Farmington, NM and Aztec, NM. Qualifying purchases exclude: alcoholic beverages, tobacco products, fluid dairy, fuel, prescription items and co-payments, fishing/hunting licenses and tags, postage stamps, money orders/transfers, bus/commuter passes, amusement park/ski/event/lottery tickets, phone cards, gift cards/certificates and applicable taxes, bottle/container deposits and bag fees.",
            "deleted": true,
            "imageId": "9",
            "extlOfferId": "82302573-D",
            "hierarchies": {
                "categories": [
                    "Baby Care"
                ],
                "events": [
                    "Weekly Ad Coupons"
                ]
            },
            "etag": "default"
        },
        {
            "offerId": "84441570",
            "categoryType": "Wine, Beer & Spirits",
            "category": "Wine, Beer & Spirits",
            "clipTs": "1705950268610",
            "description": "test ttl",
            "startDate": "1698775200000",
            "endDate": "1731006000000",
            "events": [
                "$3.50 off"
            ],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
            "limits": "O",
            "name": "test ttl",
            "brand": "test ttl",
            "offerPgm": "SC",
            "offerPrice": "test ttl",
            "offerSubPgm": "02",
            "offerTs": "1698777925180",
            "offerProgramType": "ITEM_DISCOUNT",
            "offerProtoType": "ITEM_DISCOUNT",
            "purchaseInd": "L",
            "purchaseRank": "43",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "43",
            "expiryRank": "43",
            "companionOfferIds": [],
            "disclaimer": "test ttl",
            "deleted": true,
            "imageId": "9",
            "extlOfferId": "84441570-D",
            "hierarchies": {
                "categories": [
                    "Wine, Beer & Spirits"
                ],
                "events": [
                    "$3.50 off"
                ]
            },
            "etag": "default"
        },
        {
            "offerId": "84859477",
            "categoryType": "Wine, Beer & Spirits",
            "category": "Wine, Beer & Spirits",
            "clipTs": "1705950271149",
            "description": "Postman 22 $0.66 when you buy 1 Postman Any variety.",
            "startDate": "1645988400000",
            "endDate": "1735585200000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/20f7e4d5-08e7-4714-886b-779cd6464eb3.gif",
            "limits": "O",
            "name": "ALEN Pinalen",
            "brand": "ALEN Pinalen",
            "offerPgm": "MF",
            "offerPrice": "$0.96 OFF",
            "offerSubPgm": "09",
            "offerTs": "1669213538000",
            "purchaseInd": "L",
            "purchaseRank": "41",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "41",
            "expiryRank": "41",
            "companionOfferIds": [],
            "disclaimer": "Test Legal stuff goes here",
            "deleted": true,
            "imageId": "20f7e4d5-08e7-4714-886b-779cd6464eb3",
            "extlOfferId": "22238-27024-22",
            "hierarchies": {
                "categories": [
                    "Wine, Beer & Spirits"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "85223932",
            "categoryType": "Beverages",
            "category": "Beverages",
            "clipTs": "1705950314702",
            "description": "$2.00 OFF when you buy ONE(1) Starbucks Espresso 4-pack Valid on 6.5 fl. oz. 4 pack.",
            "startDate": "1670007600000",
            "endDate": "1717178400000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2fbfceb2-0ac9-4ff0-bcc1-4e221b9e469b.gif",
            "limits": "O",
            "name": "Starbucks",
            "brand": "Starbucks",
            "offerPgm": "MF",
            "offerPrice": "$2.00 OFF",
            "offerSubPgm": "09",
            "offerTs": "1688756308000",
            "offerProgramType": "ITEM_DISCOUNT",
            "offerProtoType": "ITEM_DISCOUNT",
            "purchaseInd": "L",
            "purchaseRank": "21",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "21",
            "expiryRank": "21",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Inmar Brand Solutions Dept. 12000 Mfr Rcv Office 801 UNION PACIFIC BLVD STE 5 LAREDO TX 78045-9475. Coupon expires 12/27/2022.",
            "deleted": true,
            "imageId": "2fbfceb2-0ac9-4ff0-bcc1-4e221b9e469b",
            "extlOfferId": "00219-118570-54",
            "hierarchies": {
                "categories": [
                    "Beverages"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "86268740",
            "categoryType": "Paper, Cleaning & Home",
            "category": "Paper, Cleaning & Home",
            "clipTs": "1705950282801",
            "description": "$ 1.00 OFF - When Buy 2 Limit 1 / P13N -SPA-BIA -Offer-Test",
            "startDate": "1696010400000",
            "endDate": "1719770400000",
            "events": [
                "Flavor Adventure"
            ],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
            "limits": "U",
            "name": "SPA-Test",
            "brand": "SPA-Test",
            "offerPgm": "SC",
            "offerPrice": "$1 OFF",
            "offerSubPgm": "02",
            "offerTs": "1696012662977",
            "offerProgramType": "ITEM_DISCOUNT",
            "offerProtoType": "ITEM_DISCOUNT",
            "purchaseInd": "L",
            "purchaseRank": "29",
            "status": "C",
            "usageType": "U",
            "arrivalRank": "29",
            "expiryRank": "29",
            "companionOfferIds": [],
            "disclaimer": "$ 1.00 OFF - When Buy 2 Limit 1 / P13N -SPA-BIA - Offer-Test",
            "deleted": true,
            "imageId": "2",
            "extlOfferId": "86268740-D",
            "hierarchies": {
                "categories": [
                    "Paper, Cleaning & Home",
                    "Personal Care & Health"
                ],
                "events": [
                    "Flavor Adventure"
                ]
            },
            "etag": "default"
        },
        {
            "offerId": "87601587",
            "categoryType": "Wine, Beer & Spirits",
            "category": "Wine, Beer & Spirits",
            "clipTs": "1705950262734",
            "description": "$5.00 REBATE via PayPal when you buy TWO(2) Bread & Butter Wine Valid on TWO (2) 750mL bottles of Bread & Butter Wine and ONE (1) bread item. Items must appear on the same receipt.",
            "startDate": "1685728800000",
            "endDate": "1717178400000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/814c98f1-c84b-4f98-a000-61324db5b53c.gif",
            "limits": "O",
            "name": "Bread & Butter Wine",
            "brand": "Bread & Butter Wine",
            "offerPgm": "MF",
            "offerPrice": "$5.00 REBATE via PayPal",
            "offerSubPgm": "09",
            "offerTs": "1687556052000",
            "offerProgramType": "CUSTOM",
            "offerProtoType": "CUSTOM",
            "purchaseInd": "L",
            "purchaseRank": "45",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "45",
            "expiryRank": "45",
            "companionOfferIds": [],
            "disclaimer": "Purchase required. Items must appear on the same receipt. Offer expires 12/31/22. Purchase must occur between 11/1/22 - 12/31/22. Limit one rebate per household. VALID ONLY TO LEGAL RESIDENTS OF AR, CA, CO, CT, DC, IA, ID, IL, LA, MA, MD, ME, NE, NY, OR, SD, VA, WY. AGE 21 YEARS OR OLDER. Void where prohibited by law. This rebate may not be combined with any other offer. Proof of purchase must accompany rebate submission. Receipt photo must include retailer name, date & time of purchase, product name or item code for required purchase item. Rebate payment sent via PayPal. If you do not have a PayPal account, you will receive an email notification from PayPal with instructions to create a PayPal account and must accept the payment via PayPal within 30 days or rebate funds will be forfeited. This rebate is void if assigned, sold, transferred, duplicated or reproduced in any way. Tax remains the responsibility of the consumer. Requests from groups, clubs, organizations or any other group purchase will not be honored or returned. REDEMPTION OR HANDLING OF THIS COUPON NOT ACCORDING TO ITS TERMS CONSTITUTES FRAUD. Employees and officers of Winery Exchange, affiliated companies, licensed retailers, distributors and family members residing in the same household as any of the above are not eligible. Winery Exchange reserves the right to require additional information/identification prior to honoring rebate request and to reject non-conforming rebate requests without liability of any kind. \nAdd offers to your loyalty account prior to in-store or online check-out, then redeem in the store where you regularly shop. Offers are personalized to the loyalty account holder and store associated with the holder’s loyalty account. Offers cannot be assigned or transferred and may not be redeemable in other store locations. Offers are limited to one per customer unless otherwise stated and cannot be applied to previous purchases. Using multiple accounts to exceed limits on offers and promotions is not permitted. We reserve the right to terminate accounts if we believe they are used for such activities. Offers do not apply to online orders scheduled for delivery or pickup after the offer expiration dates. Offers cannot be doubled or combined with any other offer, savings, coupon or discount. Internet/digital coupons cannot be doubled except manufacturers’ coupons, where permitted by the issuing manufacturer and accepted by participating store locations. In the event of product return, savings may be deducted from refund. All rebate offers are subject to applicable manufacturer’s additional terms. You pay applicable taxes, bottle/can deposits, and bag fees on purchased and free items. Prices may change and vary among store locations. Prices effective on the date you place an online order may not be the same on your scheduled order delivery or pickup date. Prices for products you order online generally are higher than in our physical store locations and may vary by fulfillment method chosen. Online promotions, discounts and offers may differ from those in our physical store locations. Not all items/varieties available in all store locations. Quantities limited to inventory on hand and subject to availability. Sales in retail quantities only. Some items may be subject to manufacturers’ limitations and other requirements. While supplies last. Transactional limits may apply. No rainchecks. We reserve the right to modify or cancel offers and/or correct typographical, pictorial and other ad or pricing errors. Offer void where prohibited by law and has no cash value. Add Rebate to your Digital Account – Use Your Digital Account at time of purchase – Purchase Required Product(s) – Receive your Rebate Via PayPal in 3 to 5 Business Days. Rebate payment will be made directly to the shopper’s registered email address via PayPal within 3-5 business days. If shoppers do not have a PayPal account, they receive an email at the registered address from PayPal with prompts to set up an account and claim their rebate. In the event that shopper does not claim their funds in PayPal within 30 days of receiving confirmation email, payment will be cancelled. Processing and redemption of rebates is handled by CB Neptune Holdings LLC. For any questions or inquiries regarding redemptions, please contact Albertson’s Support: https://www.albertsons.com/contact-us.html or 1-877-723-3929 or M.S 10501 P.O Box 29093, Phoenix, AZ 85038",
            "deleted": true,
            "imageId": "814c98f1-c84b-4f98-a000-61324db5b53c",
            "extlOfferId": "22275-22638-14",
            "hierarchies": {
                "categories": [
                    "Wine, Beer & Spirits"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "89960562",
            "categoryType": "Dairy, Eggs & Cheese",
            "category": "Dairy, Eggs & Cheese",
            "clipTs": "1705950328153",
            "description": "P13N-BIA",
            "startDate": "1680112800000",
            "endDate": "1711735200000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
            "limits": "U",
            "name": "Buy 1 Get 1",
            "brand": "Buy 1 Get 1",
            "offerPgm": "SC",
            "offerPrice": "Buy 1 Get 1",
            "offerSubPgm": "02",
            "offerTs": "1680117044000",
            "offerProgramType": "BUYX_GETX",
            "offerProtoType": "BUYX_GETX",
            "purchaseInd": "L",
            "purchaseRank": "19",
            "status": "C",
            "usageType": "U",
            "arrivalRank": "19",
            "expiryRank": "19",
            "companionOfferIds": [],
            "deleted": true,
            "imageId": "2",
            "extlOfferId": "89960562-D",
            "hierarchies": {
                "categories": [
                    "Dairy, Eggs & Cheese"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "90798093",
            "categoryType": "Baby Care",
            "category": "Baby Care",
            "clipTs": "1705950363921",
            "description": "erums nonhealth5",
            "startDate": "1703098800000",
            "endDate": "1720116000000",
            "events": [
                "Weekly Ad Coupons"
            ],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
            "limits": "O",
            "name": "erums nonhealth5",
            "brand": "erums nonhealth5",
            "offerPgm": "SC",
            "offerPrice": "$15 Savings Value",
            "offerSubPgm": "02",
            "offerTs": "1703116925944",
            "offerProgramType": "BUYX_GETY",
            "offerProtoType": "BUYX_GETY",
            "purchaseInd": "L",
            "purchaseRank": "12",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "12",
            "expiryRank": "12",
            "companionOfferIds": [],
            "disclaimer": "Save $A when you spend $X, or Save $B when you spend $Y, or Save $C when you spend $Z or more in qualifying purchases in a single transaction using your just for U account ($X or $Y or $Z minimum purchase calculated after deduction of promotional and loyalty card savings, coupons and all other discounts, offers and savings). Offer is valid [INSERT START DATE] - [INSERT END DATE] only at participating Safeway and Albertsons stores located in Colorado, Nebraska, South Dakota, Eastern Wyoming, Farmington, NM and Aztec, NM. Qualifying purchases exclude: alcoholic beverages, tobacco products, fluid dairy, fuel, prescription items and co-payments, fishing/hunting licenses and tags, postage stamps, money orders/transfers, bus/commuter passes, amusement park/ski/event/lottery tickets, phone cards, gift cards/certificates and applicable taxes, bottle/container deposits and bag fees.",
            "deleted": true,
            "imageId": "9",
            "extlOfferId": "90798093-D",
            "hierarchies": {
                "categories": [
                    "Baby Care"
                ],
                "events": [
                    "Weekly Ad Coupons"
                ]
            },
            "etag": "default"
        },
        {
            "offerId": "92687859",
            "categoryType": "International Cuisine",
            "category": "International Cuisine",
            "clipTs": "1705950280912",
            "description": "Free New Pepsi when you buy TWO(2) New Pepsi Any variety. Items must appear on the same receipt.",
            "startDate": "1669662000000",
            "endDate": "1732820400000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
            "limits": "O",
            "name": "Pepsi",
            "brand": "Pepsi",
            "offerPgm": "MF",
            "offerPrice": "Free New Pepsi",
            "offerSubPgm": "09",
            "offerTs": "1669673980000",
            "purchaseInd": "L",
            "purchaseRank": "31",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "31",
            "expiryRank": "31",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: LIMIT ONE (1) COUPON PER PURCHASE OF PRODUCT & QUANTITY STATED. No more than two (2) identical coupons for same product in same day. Do not send this coupon to ColgatePalmolive. Void if transferred, sold, auctioned, reproduced or altered from original. You must pay any sales tax. RETAILER: ColgatePalmolive will reimburse the face value plus up to 10.5¢ handling if submitted in accordance with our Redemption Policy. For policy and/or coupon redemption send to: Colgate-Palmolive 1119, P.O. Box 880001, El Paso, TX 88588-0001. Cash Value 1/100¢. No cash or credit in excess of shelf price may be returned to consumer or applied to transaction. Coupon may not be bought, reproduced, transferred or sold. Void where prohibited or if transferred to any person, firm or group prior to store redemption. Valid only in the USA (not in Puerto Rico). Redeemable at Food, Drug, Discount & other stores accepting coupons. Colgate-Palmolive participates in the CIC® member Coupon Integrity Program.",
            "deleted": true,
            "imageId": "Pepsi",
            "extlOfferId": "00123-053715-57",
            "hierarchies": {
                "categories": [
                    "International Cuisine"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "93443272",
            "categoryType": "Personal Care & Health",
            "category": "Personal Care & Health",
            "clipTs": "1705950251053",
            "description": "$1.50 OFF when you buy ONE(1) ARM & HAMMER™ Toothpaste Valid on single or twin pack.",
            "startDate": "1669662000000",
            "endDate": "1732820400000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/d71511d6-9ebd-4603-9214-ba48523c88a9.gif",
            "limits": "O",
            "name": "Arm & Hammer",
            "brand": "Arm & Hammer",
            "offerPgm": "MF",
            "offerPrice": "$1.50 OFF",
            "offerSubPgm": "09",
            "offerTs": "1669673689000",
            "purchaseInd": "L",
            "purchaseRank": "46",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "46",
            "expiryRank": "46",
            "companionOfferIds": [],
            "disclaimer": "Legal Description",
            "deleted": true,
            "imageId": "d71511d6-9ebd-4603-9214-ba48523c88a9",
            "extlOfferId": "00123-33200-04",
            "hierarchies": {
                "categories": [
                    "Personal Care & Health"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "93585785",
            "categoryType": "Wine, Beer & Spirits",
            "category": "Wine, Beer & Spirits",
            "clipTs": "1705950270022",
            "description": "Postman $0.66 when you buy 1 Postman Any variety.",
            "startDate": "1645988400000",
            "endDate": "1735585200000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/20f7e4d5-08e7-4714-886b-779cd6464eb3.gif",
            "limits": "O",
            "name": "ALEN Pinalen",
            "brand": "ALEN Pinalen",
            "offerPgm": "MF",
            "offerPrice": "$0.96 OFF",
            "offerSubPgm": "09",
            "offerTs": "1669040020000",
            "purchaseInd": "L",
            "purchaseRank": "42",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "42",
            "expiryRank": "42",
            "companionOfferIds": [],
            "disclaimer": "Test Legal stuff goes here",
            "deleted": true,
            "imageId": "20f7e4d5-08e7-4714-886b-779cd6464eb3",
            "extlOfferId": "22238-27024-21",
            "hierarchies": {
                "categories": [
                    "Wine, Beer & Spirits"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "93656047",
            "categoryType": "Deli",
            "category": "Deli",
            "clipTs": "1705950279005",
            "description": "P13N-BIA",
            "startDate": "1679940000000",
            "endDate": "1711735200000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
            "limits": "O",
            "name": "$ 0.99 Off",
            "brand": "$ 0.99 Off",
            "offerPgm": "SC",
            "offerPrice": "$ 0.99 Off",
            "offerSubPgm": "02",
            "offerTs": "1679957211000",
            "offerProgramType": "ITEM_DISCOUNT",
            "offerProtoType": "ITEM_DISCOUNT",
            "purchaseInd": "L",
            "purchaseRank": "33",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "33",
            "expiryRank": "33",
            "companionOfferIds": [],
            "deleted": true,
            "imageId": "2",
            "extlOfferId": "93656047-D",
            "hierarchies": {
                "categories": [
                    "Deli"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "93683315",
            "categoryType": "Deli",
            "category": "Deli",
            "clipTs": "1705950278198",
            "description": "P13N-BIA",
            "startDate": "1679940000000",
            "endDate": "1711735200000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
            "limits": "O",
            "name": "Buy 1 Get 1",
            "brand": "Buy 1 Get 1",
            "offerPgm": "SC",
            "offerPrice": "Buy 1 Get 1",
            "offerSubPgm": "02",
            "offerTs": "1679956930000",
            "offerProgramType": "BUYX_GETX",
            "offerProtoType": "BUYX_GETX",
            "purchaseInd": "L",
            "purchaseRank": "34",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "34",
            "expiryRank": "34",
            "companionOfferIds": [],
            "deleted": true,
            "imageId": "2",
            "extlOfferId": "93683315-D",
            "hierarchies": {
                "categories": [
                    "Deli"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "95874947",
            "categoryType": "Pet Care",
            "category": "Pet Care",
            "clipTs": "1705950292757",
            "description": "Automation Testing",
            "startDate": "1706295600000",
            "endDate": "1738090800000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/test.gif",
            "limits": "O",
            "name": "Rukshesh API Auto Test MF Offer J4U API Test offers - MF Scenario",
            "brand": "Rukshesh API Auto Test MF Offer J4U API Test offers - MF Scenario",
            "offerPgm": "SC",
            "offerPrice": "Save $1.00",
            "offerTs": "1675014018000",
            "priceType": "PP",
            "purchaseInd": "L",
            "purchaseRank": "27",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "27",
            "expiryRank": "27",
            "companionOfferIds": [],
            "disclaimer": "Disclaimer",
            "deleted": true,
            "imageId": "test",
            "extlOfferId": "95874947-D",
            "hierarchies": {
                "categories": [
                    "Bread & Bakery",
                    "Pet Care"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "96016184",
            "categoryType": "Baby Care",
            "category": "Baby Care",
            "clipTs": "1705950356402",
            "description": "erums nonhealth3",
            "startDate": "1703098800000",
            "endDate": "1735066800000",
            "events": [
                "Weekly Ad Coupons"
            ],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/9.gif",
            "limits": "O",
            "name": "erums nonhealth3",
            "brand": "erums nonhealth3",
            "offerPgm": "SC",
            "offerPrice": "$15 Savings Value",
            "offerSubPgm": "02",
            "offerTs": "1703117045616",
            "offerProgramType": "BUYX_GETY",
            "offerProtoType": "BUYX_GETY",
            "purchaseInd": "L",
            "purchaseRank": "13",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "13",
            "expiryRank": "13",
            "companionOfferIds": [],
            "disclaimer": "Save $A when you spend $X, or Save $B when you spend $Y, or Save $C when you spend $Z or more in qualifying purchases in a single transaction using your just for U account ($X or $Y or $Z minimum purchase calculated after deduction of promotional and loyalty card savings, coupons and all other discounts, offers and savings). Offer is valid [INSERT START DATE] - [INSERT END DATE] only at participating Safeway and Albertsons stores located in Colorado, Nebraska, South Dakota, Eastern Wyoming, Farmington, NM and Aztec, NM. Qualifying purchases exclude: alcoholic beverages, tobacco products, fluid dairy, fuel, prescription items and co-payments, fishing/hunting licenses and tags, postage stamps, money orders/transfers, bus/commuter passes, amusement park/ski/event/lottery tickets, phone cards, gift cards/certificates and applicable taxes, bottle/container deposits and bag fees.",
            "deleted": true,
            "imageId": "9",
            "extlOfferId": "96016184-D",
            "hierarchies": {
                "categories": [
                    "Baby Care"
                ],
                "events": [
                    "Weekly Ad Coupons"
                ]
            },
            "etag": "default"
        },
        {
            "offerId": "97118533",
            "categoryType": "Personal Care & Health",
            "category": "Personal Care & Health",
            "clipTs": "1705950247794",
            "description": "$3.00 OFF when you buy TWO(2) Gillette Razor/Blade Refill Valid on Gillette Razor OR Blade Refill 4 ct or larger. Items must appear on the same receipt.",
            "startDate": "1669662000000",
            "endDate": "1732820400000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/d2c4d7b1-1cda-4c8b-870a-015d2eaf26f4.gif",
            "limits": "O",
            "name": "Gillete",
            "brand": "Gillete",
            "offerPgm": "MF",
            "offerPrice": "$3.00 OFF",
            "offerSubPgm": "09",
            "offerTs": "1670462662000",
            "purchaseInd": "L",
            "purchaseRank": "47",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "47",
            "expiryRank": "47",
            "companionOfferIds": [],
            "disclaimer": "Legal Description",
            "deleted": true,
            "imageId": "d2c4d7b1-1cda-4c8b-870a-015d2eaf26f4",
            "extlOfferId": "00123-47400-12",
            "hierarchies": {
                "categories": [
                    "Personal Care & Health"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "97321602",
            "categoryType": "Personal Care & Health",
            "category": "Personal Care & Health",
            "clipTs": "1705950243847",
            "description": "$3.00 OFF when you buy TWO(2) Gillette Razor/Blade Refill Valid on Gillette Razor OR Blade Refill 4 ct or larger. Items must appear on the same receipt.",
            "startDate": "1685728800000",
            "endDate": "1717178400000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/d2c4d7b1-1cda-4c8b-870a-015d2eaf26f4.gif",
            "limits": "O",
            "name": "Gillete",
            "brand": "Gillete",
            "offerPgm": "MF",
            "offerPrice": "$3.00 OFF",
            "offerSubPgm": "09",
            "offerTs": "1688755972000",
            "offerProgramType": "MUST_BUY",
            "offerProtoType": "MUST_BUY",
            "purchaseInd": "L",
            "purchaseRank": "49",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "49",
            "expiryRank": "49",
            "companionOfferIds": [],
            "disclaimer": "Legal Description",
            "deleted": true,
            "imageId": "d2c4d7b1-1cda-4c8b-870a-015d2eaf26f4",
            "extlOfferId": "00123-47400-20",
            "hierarchies": {
                "categories": [
                    "Personal Care & Health"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "97689274",
            "categoryType": "Dairy, Eggs & Cheese",
            "category": "Dairy, Eggs & Cheese",
            "clipTs": "1705950327223",
            "description": "P13N-BIA",
            "startDate": "1679940000000",
            "endDate": "1711735200000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
            "limits": "O",
            "name": "$ 0.99 Off",
            "brand": "$ 0.99 Off",
            "offerPgm": "SC",
            "offerPrice": "$ 0.99 Off",
            "offerSubPgm": "02",
            "offerTs": "1679958546000",
            "offerProgramType": "ITEM_DISCOUNT",
            "offerProtoType": "ITEM_DISCOUNT",
            "purchaseInd": "L",
            "purchaseRank": "20",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "20",
            "expiryRank": "20",
            "companionOfferIds": [],
            "deleted": true,
            "imageId": "2",
            "extlOfferId": "97689274-D",
            "hierarchies": {
                "categories": [
                    "Bread & Bakery",
                    "Dairy, Eggs & Cheese"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "98272723",
            "categoryType": "Frozen Foods",
            "category": "Frozen Foods",
            "clipTs": "1705950349056",
            "description": "BIA on Sale Buy X Get Y",
            "startDate": "1687543200000",
            "endDate": "1711735200000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/2.gif",
            "limits": "U",
            "name": "BIA on Sale",
            "brand": "BIA on Sale",
            "offerPgm": "SC",
            "offerPrice": "Buy X GET Y",
            "offerSubPgm": "02",
            "offerTs": "1687558385000",
            "offerProgramType": "BUYX_GETY",
            "offerProtoType": "BUYX_GETY",
            "purchaseInd": "L",
            "purchaseRank": "16",
            "status": "C",
            "usageType": "U",
            "arrivalRank": "16",
            "expiryRank": "16",
            "companionOfferIds": [],
            "deleted": true,
            "imageId": "2",
            "extlOfferId": "98272723-D",
            "hierarchies": {
                "categories": [
                    "Frozen Foods"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "99127449",
            "categoryType": "Grains, Pasta & Sides",
            "category": "Grains, Pasta & Sides",
            "clipTs": "1705950240386",
            "description": "$1.00 OFF when you buy ONE(1) Success® Rice or Quinoa Any variety.",
            "startDate": "1685642400000",
            "endDate": "1734634800000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/0cf87a57-53bd-4bbd-8c21-35c4ecc6a972.gif",
            "limits": "O",
            "name": "Success®",
            "brand": "Success®",
            "offerPgm": "MF",
            "offerPrice": "$1.00 OFF",
            "offerSubPgm": "09",
            "offerTs": "1687542341000",
            "offerProgramType": "ITEM_DISCOUNT",
            "offerProtoType": "ITEM_DISCOUNT",
            "purchaseInd": "L",
            "purchaseRank": "50",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "50",
            "expiryRank": "50",
            "companionOfferIds": [],
            "disclaimer": "Consumer: Limit one (1) coupon per purchase and quantity stated. No more than one (1) coupon for the same product in the same transaction. Retailer: Coupon will be redeemed for face value plus 8¢ handling if terms of offer have been met. Any other use constitutes fraud. VALID ONLY ON STATED PRODUCT(S). Coupon must be presented at time of purchase and prior to its expiry date. Customer must pay sales tax. No cash back or credit if coupon exceeds selling price. Void if prohibited, altered, transferred, sold, exchanged, taxed, copied or reproduced. Limit one coupon per purchase. Coupons submitted become property of the manufacturer. Reimbursement will be made only to retailer who redeemed the coupon. Cash value 1/20¢. Mail coupons to: Riviana Foods 742, P.O. Box 880001, El Paso, TX 88588-0001.",
            "deleted": true,
            "imageId": "0cf87a57-53bd-4bbd-8c21-35c4ecc6a972",
            "extlOfferId": "00227-047893-14",
            "hierarchies": {
                "categories": [
                    "Grains, Pasta & Sides"
                ],
                "events": []
            },
            "etag": "default"
        },
        {
            "offerId": "375225581",
            "categoryType": "Special Offers",
            "category": "Special Offers",
            "clipTs": "1653320178650",
            "description": "This is a new offer",
            "startDate": "1612292400000",
            "endDate": "1706727600000",
            "events": [
                "Weekly Ad Coupons"
            ],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/99999.gif",
            "limits": "U",
            "name": "New offer Feb 2021",
            "brand": "New offer Feb 2021",
            "offerPgm": "SC",
            "offerPrice": "$2.95 each",
            "offerSubPgm": "02",
            "offerTs": "1613083100000",
            "purchaseInd": "L",
            "purchaseRank": "52",
            "status": "C",
            "usageType": "U",
            "arrivalRank": "52",
            "expiryRank": "52",
            "companionOfferIds": [],
            "disclaimer": "This is a disclaimer",
            "deleted": true,
            "imageId": "99999",
            "extlOfferId": "375225581-D",
            "hierarchies": {
                "categories": [
                    "Special Offers"
                ],
                "events": [
                    "Weekly Ad Coupons"
                ]
            },
            "etag": "default"
        },
        {
            "offerId": "624266723",
            "categoryType": "Cookies, Snacks & Candy",
            "category": "Cookies, Snacks & Candy",
            "clipTs": "1692208855153",
            "description": "30-50ct Selected Varieties Lim2",
            "startDate": "1550862000000",
            "endDate": "1924974000000",
            "events": [
                "2000NewEvent2"
            ],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/999999.gif",
            "limits": "U",
            "name": "Polaris SC offer 41",
            "brand": "Polaris SC offer 41",
            "offerPgm": "SC",
            "offerPrice": "$1.00 each",
            "offerSubPgm": "01",
            "offerTs": "1578091640000",
            "purchaseInd": "L",
            "purchaseRank": "51",
            "status": "C",
            "usageType": "U",
            "arrivalRank": "51",
            "expiryRank": "51",
            "companionOfferIds": [],
            "deleted": true,
            "imageId": "999999.gif",
            "extlOfferId": "OMSPOL00041",
            "hierarchies": {
                "categories": [
                    "Cookies, Snacks & Candy"
                ],
                "events": [
                    "2000NewEvent2"
                ]
            },
            "etag": "default"
        },
        {
            "offerId": "1096879833",
            "categoryType": "Beverages",
            "category": "Beverages",
            "clipTs": "1705950299308",
            "description": "$1.00 OFF when you buy TWO(2) Pepsi Drink Any variety. Items must appear on the same receipt.",
            "startDate": "1646161200000",
            "endDate": "1714500000000",
            "events": [],
            "image": "https://ngcp-qa2.safeway.com/CMS/j4u/offers/images/Pepsi.gif",
            "limits": "O",
            "name": "Pepsi",
            "brand": "Pepsi",
            "offerPgm": "MF",
            "offerPrice": "$1.00 OFF",
            "offerSubPgm": "09",
            "offerTs": "1665086964000",
            "purchaseInd": "L",
            "purchaseRank": "26",
            "status": "C",
            "usageType": "O",
            "arrivalRank": "26",
            "expiryRank": "26",
            "companionOfferIds": [],
            "disclaimer": "CONSUMER: Only one coupon per purchase. You pay sales tax and/or deposit charge, where applicable. Coupon may not be assigned, transferred or reproduced. Any other use constitutes fraud. Cash value 1/100¢. RETAILER: We will reimburse you for the face value plus 8¢ handling if you and the consumer have complied with our Coupon Redemption Policy available at the redemption address. Mail coupons to: Pepsi-Cola Company, Inmar Brand Solutions Dept. 12000, Mfr Rcv Office, 801 Union Pacific Boulevard, STE 5, Laredo, TX 78045-9475. Coupon Expires: 4/17/2022",
            "deleted": true,
            "imageId": "Pepsi",
            "extlOfferId": "00219-23222-00",
            "hierarchies": {
                "categories": [
                    "Beverages"
                ],
                "events": []
            },
            "etag": "default"
        }
    ]

    public constructor(private _http: HttpClient, private commonService: CommonService, private utilService: UtilService, private _userInfoService: UserInfoService, private aemService: AemService) {        
        this.isMockP13nCarouselDataEnabled =
            window && window['SWY'] && ['SWY'] && 
            window['SWY']?.CONFIGSERVICE?.featureToggleConfig?.disableMockP13nCarouselData == false ? true : false;

        this.currentEnv = this.commonService.getCurrentEnviorment();
        this.GALLERY_API = this.config[this.currentEnv].baseURL;
    }

    //----------------------------------------------------------------------------
    /**
     * Current function that does not have limit or flag for the api limit param
     * currently used by j4u gallery which does not need the limit.
     */
    //-----------------------------------------------------------------------------
    public getData(carouselLimitItems?: number, isInstantAllocGrid?: boolean, isBonusPath: boolean = false): Observable<any> {
        //instant allocation flow: checking if a user is registering through a bitly link for instant allocation
        //if they are they then will have specific parameters in URL and need to call instantAllocationGallery xapi
        const storeId = this._userInfoService.getJ4uStoreId() || this._userInfoService.getShopStoreId() || this._userInfoService.getStoreId();
        const banner = this._userInfoService.getBanner();
        if (!isBonusPath) {
            this.GALLERY_API = this.config[this.currentEnv].baseURL;
            this.GALLERY_API = this.GALLERY_API.replace('{banner}', banner);
        } else {
            this.GALLERY_API = 'https://' + this.getLocationHost();
        }
        if (this.instantEventName == "new_registration" && this.instantEventDateTime != null && this.instantCorrelationId != null) {
            this.GALLERY_API += this.config[this.currentEnv].j4uAPIDetails.instantAllocation;
            this.isInstantBitlyFlow();
        } else {
            this.GALLERY_API += this.config[this.currentEnv].j4uAPIDetails.companionGalleryApi + "?storeId=" + storeId + '&rand=' + (Math.floor((Math.random() * 1000000))) + '&includeRedmBonusPathFPOffers=true';
            if (isBonusPath) {
                this.isBonusPathPage = isBonusPath;
                this.GALLERY_API = `${this.GALLERY_API}&includeOnlyBonusOffer=y`
            }
        }
        this.HTTP_OPTIONS = { headers: this.aemService.getCompanionOffersxAPIHttpOptions() };
        return this.getDataUsingCache(carouselLimitItems, isInstantAllocGrid);
    }

    /**
     * Fetches coupon data either from local cache or remotely.
     * @param {string} carouselLimitItems - The maximum number of items to display in the carousel.
     * @param {string} modelConfigurationId - The ID of the model configuration to use when fetching data from the remote API.
     * @returns {Observable<any>} An Observable that emits the fetched and processed coupon data.
     */
    public getP13nData(carouselLimitItems, modelConfigurationId: string): Observable<any> {
        const cachedCouponsObj = this.get('p13nCoupons');
        const dealsInfo = cachedCouponsObj?.dealsInfo;
        const clippedAmount = cachedCouponsObj?.arrClippedCoupons?.length;

        const currentTime = new Date().getTime()
        if (!dealsInfo || this.isLocalP13nDataInvalid(cachedCouponsObj, currentTime, carouselLimitItems)) {
            return this.getP13nRemoteData(Number(carouselLimitItems), modelConfigurationId);
        } else if (dealsInfo?.length - clippedAmount <= Number(carouselLimitItems)) {
            this.additionalResponseCount++;
            // Next clip will result in seeing clipped coupons. Need to call the API to fetch additional coupons.
            return this.getP13nRemoteData(Number(carouselLimitItems), modelConfigurationId, true);
        }

        return of(this.processAndCacheP13nCoupons(cachedCouponsObj, carouselLimitItems))
    }

    /**
     * Sorts and caches data before returning arary of items.
     * @param p13nCouponsObj Object in the format of p13nCoupons LS object
     * @param carouselLimitItems Number of items to be displayed in carousel.
     * @returns {Array} Array of first carouselLimitItems amount of objects in the array.
     */
    private processAndCacheP13nCoupons(p13nCouponsObj, carouselLimitItems) {
        const sortedCouponsObj = this.processP13nCoupons(p13nCouponsObj);
        this.set('p13nCoupons', sortedCouponsObj);
        return sortedCouponsObj.dealsInfo.slice(0, carouselLimitItems);
    }


    //----------------------------------------------------------------------------
    /**
     *  Method initialises when flag offerCarouselApiBased is true for the api limit
     *  param.
     *  Will replace getData when functionality is stable and in place.
     */
    //-----------------------------------------------------------------------------

    public getApiData(carouselLimitItems?: number, isInstantAllocGrid?: boolean): Observable<any> {
        //instant allocation flow: checking if a user is registering through a bitly link for instant allocation
        //if they are they then will have specific parameters in URL and need to call instantAllocationGallery xapi
        const storeId = this._userInfoService.getShopStoreId();
        const banner = this._userInfoService.getBanner();
        this.GALLERY_API = this.GALLERY_API.replace('{banner}', banner);
        if (this.instantEventName == "new_registration" && this.instantEventDateTime != null && this.instantCorrelationId != null) {
            this.GALLERY_API += this.config[this.currentEnv].j4uAPIDetails.instantAllocation;
            this.isInstantBitlyFlow();
        } else {
            this.GALLERY_API += this.config[this.currentEnv].j4uAPIDetails.companionGalleryApi + "?storeId=" + storeId + '&includeRedmBonusPathFPOffers=true';
            // NS-46825 - Add the hpGuest flag when anonymous
            if (window['AB']['COMMON'].authorize() === false) {
                this.GALLERY_API += '&hpGuest=true';
            } else {
                this.GALLERY_API += '&rand=' + (Math.floor((Math.random() * 1000000)));
            }
            // when the limit is set to 99999 don't send it to the backend
            if (carouselLimitItems && carouselLimitItems != 99999 ) {
                this.GALLERY_API += '&limit=' + carouselLimitItems;
            }
        }
        this.HTTP_OPTIONS = { headers: this.aemService.getCompanionOffersxAPIHttpOptions() };

        return this.getRemoteAPIData(this.GALLERY_API, this.HTTP_OPTIONS, carouselLimitItems, isInstantAllocGrid, false);
    }

    public isInstantBitlyFlow() {
        //setting request body for the instant allocation xapi post call
        const externalOfferId = window['AB']['COMMON'].getURLParameterByName("externalOfferId");
        const offerId = window['AB']['COMMON'].getURLParameterByName("offerId");
        const division = window['AB']['COMMON'].getURLParameterByName("division");
        const reqBody = {
            "customerId": window['AB']['userInfo'].customerId,
            "householdId": window['AB']['userInfo'].houseId,
            "eventCorrelationId": this.instantCorrelationId,
            "eventDateTime": this.instantEventDateTime,
            "eventName": this.instantEventName,
            "storeId": window['AB']['COMMON'].getURLParameterByName("storeId") ? window['AB']['COMMON'].getURLParameterByName("storeId") : window['AB']['userInfo']['j4u'].storeId,
          };
          if (offerId && externalOfferId) {
              reqBody['offers'] = [{"externalOfferId": externalOfferId, "offerId": offerId}];
          }
          if (division) {
              reqBody['division'] = window['AB']['COMMON'].getURLParameterByName("division");
          }
          this.instantAllocationReqBody = reqBody;
    }

    public getDataUsingCache(carouselLimitItems: number = 99999, isInstantAllocGrid: boolean = false): Observable<any> {
        const abJ4uCoupons = this.get('abJ4uCoupons');
        this.isDataCached = true;
        let currentTime: any = new Date();
        currentTime = Date.parse(currentTime);

        if (abJ4uCoupons && !abJ4uCoupons.isHiddenEvents && !this.isBonusPathPage) {            

            /* Check if LocalStorage is updated */
            if (this.isLocalDataInvalid(abJ4uCoupons, currentTime, carouselLimitItems)) {
                return this.getRemoteData(this.GALLERY_API, this.HTTP_OPTIONS, carouselLimitItems, isInstantAllocGrid, false);
            } else {
                if (window.location.href.includes('coupons-deals') || window.location.href.includes('discovery')){
                    this.onCouponsAndDealsPageReload = false;
                    return this.getRemoteData(`${this.GALLERY_API}`, this.HTTP_OPTIONS, carouselLimitItems, isInstantAllocGrid, false);
                } else {
                    return of(this.returnFromLocalStorage(isInstantAllocGrid,abJ4uCoupons,carouselLimitItems));
                }
            }
        }
        else {
            return this.getRemoteData(this.GALLERY_API, this.HTTP_OPTIONS, carouselLimitItems, isInstantAllocGrid, false);
        }
    }

    public returnFromLocalStorage(isInstantAllocGrid,abJ4uCoupons,carouselLimitItems){
        if (isInstantAllocGrid) {
            return (abJ4uCoupons.instantAllocOffer);
        }
        /* Check if there is a limit of coupons */
        else if (carouselLimitItems) {
            return (this.sortMappedCoupons(abJ4uCoupons.objCoupons).splice(0, carouselLimitItems));
        } else {
            return (this.sortMappedCoupons(abJ4uCoupons.objCoupons));
            //  return of(abJ4uCoupons.objCoupons);
        }
    }

    public getLocationHost(): string {
        return window.location.host;
    }

    public sortMappedCoupons(data) {
        const sorted = Object.values(data).sort((a:any,b:any) =>  a.purchaseRank - b.purchaseRank );

        // single pass thru the array
        const couponsClipped = [];
        const couponsUnclipped = [];
        const unclippedPD = [];
        const unclippedOthers = [];
        sorted.forEach(coupon => {
            if (coupon['status'] === 'C') {
                couponsClipped.push(coupon);
            }
            if (coupon['status'] === 'U') {
                couponsUnclipped.push(coupon);
                if (coupon['offerType'] === 'PD') {
                    unclippedPD.push(coupon);
                } else {
                    unclippedOthers.push(coupon);
                }
            }
        });

        return [...unclippedPD, ...unclippedOthers, ...couponsClipped];
    }

    /**
     * Sorts coupons by adding new coupons to end of unclipped coupons, if any exist, and adds clipped coupons to object.
     * Returns data in format ready to use in p13nCoupons LS object.
     * @param savingData In the format of p13nCoupons LS object. 
     * @param additionalCouponsResponse The response returned from the API call.
     * @returns Object in format of p13nCoupons LS object.
     */
    public processP13nCoupons(savingData, additionalCouponsResponse?) {
        const localCoupons = savingData?.dealsInfo ?? [];
        const localClippedCoupons = savingData?.arrClippedCoupons ?? [];
        const localCouponsMap = new Map(localCoupons.map(coupon => [coupon.offerId, coupon]));
        
        const mappedAdditionalCouponsResponse = this.mapP13nCoupons(additionalCouponsResponse);
        const deduplicatedCouponsResponse = this.removeDuplicates(mappedAdditionalCouponsResponse, localCouponsMap)
        const additionalClippedCoupons = deduplicatedCouponsResponse.clippedCoupons ?? [];
        
        const allClippedCoupons = [...localClippedCoupons, ...additionalClippedCoupons];
        
        // Add clipped coupons to array in the order they were clipped.
        const clippedCoupons = [];
        allClippedCoupons.forEach((offerId) => {
            const coupon = localCouponsMap.get(offerId);
            if (coupon) {
                clippedCoupons.push(coupon);
            }
        });

        const unclippedCoupons = localCoupons.filter((coupon: any) => coupon.status === 'U');

        const allUnclippedCoupons = additionalCouponsResponse ? [...unclippedCoupons, ...deduplicatedCouponsResponse.coupons] : unclippedCoupons;
       
        const coupons = savingData ?? {};
        coupons.dealsInfo = [...allUnclippedCoupons, ...clippedCoupons];

        return coupons;
    }

    private removeDuplicates(mappedCouponsResponse, couponMap: Map<any, any>) {
        let clippedCoupons = mappedCouponsResponse?.clippedCoupons ?? [];
        let coupons = mappedCouponsResponse?.coupons ?? [];
        clippedCoupons = clippedCoupons.filter((couponId) => !couponMap.has(couponId));
        coupons = coupons.filter((coupon) => !couponMap.has(coupon.offerId));

        return {
            coupons,
            clippedCoupons
        }
    }

    public sortByPurchaseRank(data) {
        const sorted = Object.values(data).sort((a:any,b:any) =>  a.purchaseRank - b.purchaseRank );

        return sorted;
    }

    public isLocalDataInvalid(abJ4uCoupons, currentTime, carouselLimitItems) {
        let couponsClipped = window['AB']['COMMON'].getURLParameterByName("couponsClipped")
        if (isNaN(parseInt(couponsClipped))) {
            couponsClipped = "0";
        }
        return abJ4uCoupons.objCoupons == undefined
            || abJ4uCoupons.updatedTime == ''
            || (currentTime - Number(abJ4uCoupons.savedTime)) / 1000 / 60 > 120
            || abJ4uCoupons.storeId != window['AB'].userInfo.j4u.storeId
            || parseInt(couponsClipped) > 0
            || abJ4uCoupons.authorize != window['AB']['COMMON'].authorize()
            || abJ4uCoupons.carouselLimitItems < carouselLimitItems;
    }

    public isLocalP13nDataInvalid(p13nCoupons, currentTime, carouselLimitItems) {
        let couponsClipped = window['AB']['COMMON'].getURLParameterByName("couponsClipped")
        if (isNaN(parseInt(couponsClipped))) {
            couponsClipped = "0";
        }
        return p13nCoupons.dealsInfo == undefined
            || p13nCoupons.updatedTime == ''
            || (currentTime - Number(p13nCoupons.savedTime)) / 1000 / 60 > 120
            || p13nCoupons.storeId != window['AB'].userInfo.j4u.storeId
            || parseInt(couponsClipped) > 0
            || p13nCoupons.authorize != window['AB']['COMMON'].authorize()
            || p13nCoupons.carouselLimitItems < carouselLimitItems;
    }

    public getRemoteData(url, httpHeaders, carouselLimitItems, isInstantAllocGrid, isHiddenEvents): Observable<any> {
        this.isDataCached = false;
        let result: Observable<any[] | ''> = defer(() => of([]));
        const authorize = window['AB']['COMMON'].authorize();
        //checking to see if the instantAllocation request body is populated
        //if it is - then need to make post call to instantAllocationGallery xapi
        if (Object.keys(this.instantAllocationReqBody).length !== 0) {
            result = this._http.post ( this.GALLERY_API, this.instantAllocationReqBody, this.HTTP_OPTIONS ).pipe(
                map((response) => {
                    if (response) {
                        const storeId = this.instantAllocationReqBody['storeId'] ? this.instantAllocationReqBody['storeId'] : window['AB'].userInfo.j4u.storeId;
                        let updatedTime: any = new Date();
                        updatedTime = Date.parse(updatedTime);
    
    
                        // single pass thru mapCoupons
                        const mappedCoupons = this.mapCoupons(response);
                        const objCoupons = mappedCoupons['coupons'];
                        const instantAllocOffer = mappedCoupons['instantAllocOffer'];
                        const arrClippedCoupons = mappedCoupons['couponsClipped'];
    
                        const savingData = {
                            storeId,
                            updatedTime,
                            objCoupons,
                            arrClippedCoupons,
                            instantAllocOffer,
                            isHiddenEvents,
                            authorize,
                            carouselLimitItems
                        };
    
                        this.updateabJ4uCoupons(response, savingData);
                        
                        const objSortedCoupons = this.sortMappedCoupons(objCoupons);
                        if(this.onCouponsAndDealsPageReload){
                            this.onCouponsAndDealsPageReload = false;
                            const abJ4uCoupons = JSON.parse(localStorage.getItem("abJ4uCoupons"));
                            return this.returnFromLocalStorage(isInstantAllocGrid,abJ4uCoupons,carouselLimitItems)
                        }else{
                            if (isInstantAllocGrid) {
                                return instantAllocOffer;       
                            } else if (carouselLimitItems) {
                                return objSortedCoupons.splice(0, carouselLimitItems);
                            } else {
                                return objSortedCoupons;
                            }
                        }
                    } else {
                        return '';
                    }
                }),
            );
        } else {
            //if not instant allocation bitly flow, make call to normal companionGalleryOffers xapi
            result = this._http.get<CouponModel[]>(url, httpHeaders).pipe(
                map((response) => {
                    if (response) {
                        const storeId = window['AB'].userInfo.j4u.storeId;
                        let updatedTime: any = new Date();
                        updatedTime = Date.parse(updatedTime);
    
                        // single pass thru mapCoupons
                        const mappedCoupons = this.mapCoupons(response);
                        const objCoupons = mappedCoupons['coupons'];
                        const instantAllocOffer = mappedCoupons['instantAllocOffer'];
                        const arrClippedCoupons = mappedCoupons['couponsClipped'];
    
                        const savingData = {
                            storeId,
                            updatedTime,
                            objCoupons,
                            arrClippedCoupons,
                            instantAllocOffer,
                            isHiddenEvents,
                            authorize,
                            carouselLimitItems
                        };
    
                        this.updateabJ4uCoupons(response, savingData)
    
                        const objSortedCoupons = this.sortMappedCoupons(objCoupons);
    
                        if (window['AB']?.DATALAYER?.setP13nExperimentExposure) {
                            window['AB']?.DATALAYER.setP13nExperimentExposure(response, 'deals');
                        } else if(window['AB']?.DATALAYER?.setP13nImpressions) {
                            window['AB']?.DATALAYER.setP13nImpressions(response, 'deals');
                        }
                        if(this.onCouponsAndDealsPageReload){
                            this.onCouponsAndDealsPageReload = false;
                            const abJ4uCoupons = JSON.parse(localStorage.getItem("abJ4uCoupons"));
                            return this.returnFromLocalStorage(isInstantAllocGrid,abJ4uCoupons,carouselLimitItems)
                        }else{
                            if (isInstantAllocGrid) {
                                return instantAllocOffer;       
                            } else if (carouselLimitItems) {
                                return objSortedCoupons.splice(0, carouselLimitItems);
                            } else {
                                return objSortedCoupons;
                            }
                        }
                    } else {
                        return '';
                    }
                })
            );
        }
        return result;
    }

    /**
     * Creates object to be saved to LS for p13nCoupons.
     * 
     * @param {Object} response API response
     * @param {Number} carouselLimitItems 
     * @returns {Object} An object containing the data to be saved, including the store ID, update time, deals info, clipped coupons, authorization status, and carousel limit.
     */ 
    private createP13nSavingData(response, carouselLimitItems: number) {
        const authorize = window['AB']['COMMON'].authorize();
        const storeId = window['AB'].userInfo.branchId;
        let updatedTime: any = new Date();
        updatedTime = Date.parse(updatedTime);
        // single pass thru mapCoupons
        const mappedCoupons = this.mapP13nCoupons(response);
        const dealsInfo = mappedCoupons['coupons'];
        const arrClippedCoupons = response?.arrClippedCoupons ? response.arrClippedCoupons : [];
        const dynamicFields = this.handleDynamicP13nFields(response);

        const savingData = {
            storeId,
            updatedTime,
            dealsInfo,
            arrClippedCoupons,
            isHiddenEvents: false,
            authorize,
            carouselLimitItems,
            ...dynamicFields
        };

        return savingData;
    }

    private handleDynamicP13nFields(response) {
        const dynamicFields = {};
        this.setDynamicP13nField(dynamicFields, 'carouselTitle', response?.title);
        this.setDynamicP13nField(dynamicFields, 'webCtaText', response?.ctaText);
        this.setDynamicP13nField(dynamicFields, 'webCtaLink', response?.ctaLink);
        return dynamicFields;
    }

    private setDynamicP13nField(dynamicFields, key: string, value: string): void {
        if (value) {
            dynamicFields[key] = value;
        }
    }

    public getP13nRemoteData(carouselLimitItems: number, modelConfigurationId: string, isAdditionalOffers?: boolean): Observable<any> {
        const p13nOptions = {headers: new HttpHeaders(window['AB'].p13nxApiHttpOptions)}; 
        this.isDataCached = false;
      
        const localCouponObj = this.get('p13nCoupons');

        const numCouponsToFetch = isAdditionalOffers ? this.additionalCouponsAmount : carouselLimitItems + this.additionalCouponsAmount;
        const body = this.createP13nBody(numCouponsToFetch, modelConfigurationId);

        return this._http.post(this.p13nApi, body, p13nOptions).pipe(map((response: any) => {
            // response = {dealsInfo: this.mockInitialResponse.slice(0, carouselLimitItems + this.additionalCouponsAmount)};
            // response = {dealsInfo: this.mockInitialResponse.slice(0, carouselLimitItems)};
            // response = isAdditionalOffers ? undefined : { dealsInfo: this.mockInitialResponse.slice(0, carouselLimitItems + this.additionalCouponsAmount) };
            // response = undefined
            if (this.isMockP13nCarouselDataEnabled) {
                response = this.getMockP13nCarouselData(isAdditionalOffers, carouselLimitItems)
            }

            if (!this.isValidP13nResponse(response)) {
                return this.handleP13nRemoteDataError(localCouponObj, carouselLimitItems)
            }

            const data = isAdditionalOffers ? localCouponObj : response;

            const savingData = this.createP13nSavingData(data, carouselLimitItems);

            if (isAdditionalOffers) {
                const sortedCoupons = this.processP13nCoupons(savingData, response);
                savingData.dealsInfo = sortedCoupons.dealsInfo;
            }

            this.set('p13nCoupons', savingData);
            
            if (window['AB']?.DATALAYER?.setP13nExperimentExposure) {
                window['AB']?.DATALAYER.setP13nExperimentExposure(response, 'deals');
            } else if(window['AB']?.DATALAYER?.setP13nImpressions) {
                window['AB']?.DATALAYER.setP13nImpressions(response, 'deals');
            }

            return savingData.dealsInfo.slice(0, carouselLimitItems);
        }), catchError(error => {
            this.additionalResponseCount--;
            return of(this.handleP13nRemoteDataError(localCouponObj, carouselLimitItems))
        }));
    }

    private getMockP13nCarouselData(isAdditionalOffers: boolean, carouselLimitItems: number) {
        return isAdditionalOffers 
            ? { dealsInfo: this.mockInitialResponse.slice((carouselLimitItems + this.additionalCouponsAmount * this.additionalResponseCount), carouselLimitItems + (this.additionalCouponsAmount * (1 + this.additionalResponseCount))) } 
            : { dealsInfo: this.mockInitialResponse.slice(0, carouselLimitItems + this.additionalCouponsAmount) };
    }
    
    private isValidP13nResponse(response: any) {
        return response?.dealsInfo != null && response?.dealsInfo?.length > 0;
    }

    private handleP13nRemoteDataError(localCouponObj, carouselLimitItems) {
         // Already have existing LS object. Can just do cache functionality.
         if (localCouponObj?.dealsInfo) {
            return this.processAndCacheP13nCoupons(localCouponObj, carouselLimitItems);
        }
        // Initial API call as no coupon obj already exists. Return empty array and do not render.
        return []
    }


    public createP13nBody(carouselLimitItems: number, modelConfigurationId: string) {
        const AB = window['AB'];
        return {
            "modelConfigurationId": modelConfigurationId,
            "assortmentChannel": AB.COMMON.getUserChannel(),
            "banner": AB.userInfo.banner, 
            "storeId": AB.userInfo.branchId,
            "householdId":AB.userInfo.houseId,
            "uiPageSize": carouselLimitItems, 
            "zipCode": AB.userInfo.zipcode,
            "host": window.location.origin,
            "platform": 'web'

        }
    }

    private updateabJ4uCoupons(data, savingData){
        if(this.isBonusPathPage || (!this.isBonusPathPage && window.location.href.includes('coupons-deals') && JSON.stringify(this.get("abJ4uCoupons")) != '{}')){
            const abJ4uCoupons = JSON.parse(localStorage.getItem("abJ4uCoupons"));
            if (abJ4uCoupons && data && data.companionGalleryOffer) {
                for (const behaviorCoupon in data.companionGalleryOffer) {
                    if(abJ4uCoupons.objCoupons[behaviorCoupon] && abJ4uCoupons.objCoupons[behaviorCoupon].offerId === behaviorCoupon) {
                        abJ4uCoupons.objCoupons[behaviorCoupon] = {
                            ...abJ4uCoupons.objCoupons[behaviorCoupon],
                            ...(abJ4uCoupons?.objCoupons?.[behaviorCoupon]?.continuity && data.companionGalleryOffer[behaviorCoupon]?.continuity && {
                                continuity:{
                                    ...data.companionGalleryOffer[behaviorCoupon]?.continuity,
                                    progressValue: data?.companionGalleryOffer[behaviorCoupon]?.continuity?.progressValue,
                                    targetValue: data?.companionGalleryOffer[behaviorCoupon]?.continuity?.targetValue,

                                },
                            }),
                            ...(data.companionGalleryOffer[behaviorCoupon]?.bonusPathStatus && {
                                bonusPathStatus: data.companionGalleryOffer[behaviorCoupon].bonusPathStatus
                            }),       
                            status: data.companionGalleryOffer[behaviorCoupon].status,
                            deleted: data.companionGalleryOffer[behaviorCoupon].deleted
                        }
                    } else {
                        abJ4uCoupons.objCoupons[behaviorCoupon] = data.companionGalleryOffer[behaviorCoupon];
                    }
                }
                this.set('abJ4uCoupons', abJ4uCoupons);
            }
        }else{
            this.set('abJ4uCoupons', savingData);
        }
    }

    //----------------------------------------------------------------------------
    /**
     *  Method initialises when flag offerCarouselApiBased is true for the api limit
     *  param.
     *  Will replace getRemoteData when functionality is stable.
     *  Returns    --> response["companionGalleryOffer"]
     */
    //-----------------------------------------------------------------------------

    public getRemoteAPIData(url, httpHeaders, carouselLimitItems, isInstantAllocGrid, isHiddenEvents): Observable<any> {
        this.isDataCached = false;
        let result: Observable<any[] | ''> = defer(() => of([]));
        //checking to see if the instantAllocation request body is populated
        //if it is - then need to make post call to instantAllocationGallery xapi

        //This call needs to be changed once the new API with length, filtering and sorting is done
        if (Object.keys(this.instantAllocationReqBody).length !== 0) {
            result = this._http.post ( this.GALLERY_API, this.instantAllocationReqBody, this.HTTP_OPTIONS ).pipe(
                map((response) => {
                    if (response) {

                        // single pass thru mapCoupons
                        const mappedCoupons = this.mapCoupons(response);
                        let objCoupons;
                        if (window['AB']['COMMON'].authorize()) {
                            objCoupons = this.sortByPurchaseRank(mappedCoupons['coupons']);
                        } else {
                            objCoupons = Object.values(mappedCoupons['coupons']);
                        }
                        const instantAllocOffer = mappedCoupons['instantAllocOffer'];
    
                        if (isInstantAllocGrid) {
                            return instantAllocOffer;
                        } else if (carouselLimitItems) {
                            return objCoupons.splice(0, carouselLimitItems);
                        } else {
                            return objCoupons;
                        }
                    } else {
                        return '';
                    }
                })
            );
        } else {
            //if not instant allocation bitly flow, make call to normal companionGalleryOffers xapi
            result = this._http.get<CouponModel[]>(url, httpHeaders).pipe(
                map((response) => {
                    if (response) {
                        // convert from object of objects to array of objects
                        let objCoupons;
                        // need to do this sorting because mapping the response sorts the response by offerid automatically since the primary value can be converted to numeric value
                        if (window['AB']['COMMON'].authorize()) {
                            objCoupons = this.sortByPurchaseRank(response['companionGalleryOffer']);
                        } else {
                            objCoupons = Object.values(response['companionGalleryOffer']);
                        }
                        return objCoupons;
                    } else {
                        return '';
                    }
                })
            );
        }
        return result;
    }

    public getHiddenEventsMapping(data){
        let coupons = [];
        let couponsClipped = [];
        if (data && data.offers) {
            data.offers.forEach(coupon => {
                coupon['clipStatus'] = coupon['deleted'] ? 'U' : coupon['clipStatus'];
                if (coupon['clipStatus'] == 'C') {
                    const couponId = (typeof coupon['couponID'] == 'undefined') ? coupon['offerId'] : coupon['couponID'];
                    couponsClipped = [...couponsClipped, couponId];
                }
                const endDate = coupon['offerEndDt'];
                coupon['status'] = coupon['clipStatus'] ? coupon['clipStatus'] : "";
                coupon['category'] = coupon.category ? coupon.category : "";
                coupon['events'] = coupon['events'] ? coupon['events'] : [];
                coupon['brand'] = (coupon['titleDsc1'] ? coupon['titleDsc1'] : "") + (coupon['titleDsc2'] ? " " + coupon['titleDsc2'] : "") + (coupon['titleDsc3'] ? " " + coupon['titleDsc3'] : "");
                coupon['description'] = (coupon['prodDsc1'] ? coupon['prodDsc1'] : "") + (coupon['prodDsc2'] ? " " + coupon['prodDsc2'] : "") + (coupon['prodDsc3'] ? " " + coupon['prodDsc3'] : "");
                //hot fix for having coupons on hidden events page show correct expiration date
                if (endDate.indexOf('-') !== -1) {
                    coupon['endDate'] = endDate.split('-')[1] + '/' + endDate.split('-')[2] + '/' + endDate.split('-')[0];
                }
                else {
                    coupon['endDate'] = endDate ? new Date(endDate).getTime() : "";
                }
                coupon['startDate'] = coupon['offerStartDt'] ? new Date(coupon['offerStartDt']).getTime() : "";
                coupon['offerPrice'] = coupon['savingsValue'] ? coupon['savingsValue'] : "";
                coupon['imageId'] = coupon['imageId'] ? coupon['imageId'] : "";
                coupon['image'] = window['SWY'].CONFIGSERVICE.nimbusConfig.couponImageBaseUrl + coupon['imageId'];
            });
            coupons = data.offers;
        }
        return coupons;
    }
    private mapCoupons(data) {
        let couponsClipped = [];
        let coupons = [];
        const instantAllocOffer = [];
        const companionCoupons = data.companionGalleryOffer;
        if (companionCoupons != null) {
            for (const index in companionCoupons) {
                const coupon = companionCoupons[index];
                if (coupon != undefined) {
                    coupon.status = coupon.deleted ? 'U' : coupon.status;
                    coupon.offerType = (coupon.offerPgm == "PD") ? "PD" : "CC";
                    coupon.category = coupon.category ? coupon.category : coupon.categoryType;
                    coupon.brand = coupon.brand ? coupon.brand : coupon.name;
                    coupon.events = coupon.events ? coupon.events : [];
                    coupon.image = coupon.image ? coupon.image : window['SWY'].CONFIGSERVICE.nimbusConfig.couponImageBaseUrl + coupon.imageId;
                    if (coupon.status == 'C') {
                        couponsClipped = [...couponsClipped, coupon.offerId];
                    }
                    else {
                        for (const event of coupon.events) {
                            if (event == 'Welcome Offers') {
                                instantAllocOffer.push(coupon);
                                coupon.instantAllocation = true;
                            }
                        }
                    }
                }
            }
            coupons = companionCoupons;
        } else if (data && data.offers != null) {
            coupons = this.getHiddenEventsMapping(data);
        }

        const response = {
            coupons,
            instantAllocOffer,
            couponsClipped
        };
        return response;
}

    /**
     * Maps the p13n deals api response to an object containing two arrays for coupons and clippedCoupons.
     * @param data - API response.
     */
    private mapP13nCoupons(data) {
        const fetchedCoupons = data?.dealsInfo;
        const clippedCoupons = [];
        const coupons = [];

        fetchedCoupons?.forEach((coupon) => {
            if (coupon) {
                const newCoupon = {
                    ...coupon,
                    status: coupon.deleted ? 'U' : coupon.status,
                    offerType: coupon.offerPgm == "PD" ? "PD" : "CC",
                    category: coupon.category ?? coupon.categoryType,
                    brand: coupon.brand ?? coupon.name,
                    events: coupon.events ?? [],
                    image: coupon.image ?? window['SWY'].CONFIGSERVICE.nimbusConfig.couponImageBaseUrl + coupon.imageId,
                };
                if (newCoupon.status == 'C') {
                    clippedCoupons.push(newCoupon.offerId);
                }
                coupons.push(newCoupon);
            }
        });
        return { coupons, clippedCoupons };
    }

    public getSubscriptionApiData() {
        const banner = this._userInfoService.getBanner();
        this.SUBSCRIPTION_API = this.config[this.currentEnv].baseURL;
        this.SUBSCRIPTION_API = this.SUBSCRIPTION_API.replace('{banner}', banner);
        this.SUBSCRIPTION_API += this.config[this.currentEnv].subscriptionAPIDetails.subscriptionApi;
        this.SUBSCRIPTION_API = this.SUBSCRIPTION_API.replace('{gid}', window['AB'].userInfo.UUID);
        const http_options = { 
                'Authorization': 'Bearer ' + window['AB'].userInfo.SWY_SHOP_TOKEN,
                'Accept': 'application/vnd.safeway.v2+json',
                'banner': window['SWY'].CONFIGSERVICE.getResolvedBanner(),
                'ocp-apim-subscription-key': this.config[this.currentEnv].subscriptionAPIDetails.subscriptionKey.value,
                'Content-Type': 'application/json',
                'x-swy-client-id': 'web-portal',
                'X-SWY_BANNER': window['SWY'].CONFIGSERVICE.getResolvedBanner(),
                'cache-control': 'no-cache'
         };
         return this._http.get(this.SUBSCRIPTION_API, { headers: http_options });
    }

    public set(key: string, data: any) {
        if (this.utilService.isLSCompatible()) {
            try {
                localStorage.setItem(key, JSON.stringify(data));
            } catch (e) {
                console.error('ERROR: WWW COUPON - SETTING IN LOCAL STORAGE', e);
            }
        } else {
            this.objCoupons = data;
        }
    }

    public get(key): any {
        this.objCoupons = {};
        if (this.utilService.isLSCompatible() && Object.keys(this.objCoupons).length === 0) {
            const strCoupons = localStorage.getItem(key);
            try {
                if (strCoupons) {
                    this.objCoupons = JSON.parse(strCoupons);
                }
            }
            catch (e) {
                console.error("ERROR: WWW COUPON - GETTING FROM LOCAL STORAGE", e);
            }
        }
        return this.objCoupons;
    }

    public changeBannerOnFilter(event, modUnitParam) {
        let categoryMapping = {};
        try {
            categoryMapping = JSON.parse($('.just-for-you-category-mapping-json').text().trim());
        } catch(e) {
            categoryMapping = {};
        }

        // find first category or event key that matches a selected checkbox
        const selected = [];
        $("#filter_by_coupon_category :checked").each( (index, elem) => { selected.push($(elem).attr('id'))});
        $("#filter_by_coupon_events :checked").each( (index, elem) => { selected.push($(elem).attr('id'))});

        let categoryKey = null;
        for (const item of selected) {
            const exists = Object.keys(categoryMapping['categoryMapping']).includes(item);
            if (exists) {
                categoryKey = item;
                break;
            }
        };

        if (this.defaultModUnitImage.src == null) {
            this.defaultModUnitImage.src = $('.mod-unit img').attr('src');
            this.defaultModUnitImage.alt = $('.mod-unit img').attr('alt');
            this.defaultModUnitImage.openNewTab = $('.mod-unit img').attr('openNewTab');
            this.defaultModUnitImage.dataSrc = $('.mod-unit img').attr('data-src');
            this.defaultModUnitImage.target = $('.mod-unit a').first().attr('href');
        }


        const imagePath = 'https://images.albertsons-media.com/is/image/ABS/';

        if (categoryKey) {

            $('.mod-unit img').attr({
                src: imagePath + categoryMapping['categoryMapping'][categoryKey]['imageName'] + '?' + modUnitParam,
                alt: categoryMapping['categoryMapping'][categoryKey]['imageAltText'],
                openNewTab: categoryMapping['categoryMapping'][categoryKey]['openNewTab']
            });
            $('.mod-unit img').attr('data-src', imagePath + categoryMapping['categoryMapping'][categoryKey]['imageName'] + '?' + modUnitParam );
            $('.mod-unit a').first().attr({
                href: categoryMapping['categoryMapping'][categoryKey]['targetURL'],
            });
            $('.text-plate-container').hide();
            $('.mod-unit__card').hide();

        } else {

            if (this.defaultModUnitImage.src != null) {
                $('.mod-unit img').attr({
                    src: this.defaultModUnitImage.src,
                    alt: this.defaultModUnitImage.alt,
                    openNewTab: this.defaultModUnitImage.openNewTab
                });
                $('.mod-unit img').attr('data-src', this.defaultModUnitImage.dataSrc );

                $('.mod-unit a').first().attr({
                    href: this.defaultModUnitImage.target
                });
            }

            $('.text-plate-container').show();
            $('.mod-unit__card').show();
        }
    }

    public initialBannerChange(filterParam, modUnitParam?) {
        const filterInURL = window['AB']['COMMON'].getURLParameterByName(filterParam)
            ? window['AB']['COMMON'].getURLParameterByName(filterParam).split(',')
            : '';
        const categoryMapping = JSON.parse($('.just-for-you-category-mapping').text().trim());
        const categoryKey = Object.keys(categoryMapping.categoryMapping).find(category => category === filterInURL.toString());
        const imagePath = 'https://images.albertsons-media.com/is/image/ABS/';

        if (categoryKey && this.getURLParameter()) {
            $('.mod-unit img').attr({
                src: imagePath + categoryMapping['categoryMapping'][categoryKey]['imageName'] + '?' + modUnitParam,
                alt: categoryMapping['categoryMapping'][categoryKey]['imageAltText'],
                openNewTab: categoryMapping['categoryMapping'][categoryKey]['openNewTab']
            });
            $('.mod-unit img').attr('data-src', imagePath + categoryMapping['categoryMapping'][categoryKey]['imageName'] + '?' + modUnitParam );
            $('.mod-unit a').first().attr({
                href: categoryMapping['categoryMapping'][categoryKey]['targetURL'],
            });
            $('.text-plate-container').hide();
        }
    }

    public getURLParameter() {
        const categories = window['AB']['COMMON'].getURLParameterByName('category')
            ? window['AB']['COMMON'].getURLParameterByName('category')
            : '';

        const events = window['AB']['COMMON'].getURLParameterByName('event')
            ? window['AB']['COMMON'].getURLParameterByName('event')
            : '';

        const offerType = window['AB']['COMMON'].getURLParameterByName('offerPgm')
            ? window['AB']['COMMON'].getURLParameterByName('offerPgm')
            : '';

        const filter = [];

        if (categories) {
            filter.push(categories);
        }
        if (events) {
            filter.push(events);
        }
        if (offerType) {
            filter.push(offerType);
        }

        return (filter.length < 2);

    }

    public clipCoupon(coupon: any, storeId: string, configObj?: IConfigObj, isP13nCoupon?: boolean, analyticsData?: any): Observable<any> {
        const httpOptions = {headers: new HttpHeaders(this.aemService.getJ4uHttpOptions())};
        const banner = this._userInfoService.getBanner();
        let clipUrl = window.location.host.includes("business")? window.location.origin :this.config[this.currentEnv].baseURL.replace('{banner}', banner);
        clipUrl += this.config[this.currentEnv].j4uAPIDetails.clipPath + "?storeId=" + storeId;
        // if (configObj && configObj.bannerDomain) {
        //     clipUrl = configObj.bannerDomain + clipUrl;
        // }
        let result: Observable<any> = defer(() => of({}));
        let reqBody = {};

        if(coupon.deleted) {
            reqBody = {
                items: [
                    {
                        clipType: 'L',
                        itemId: coupon.offerId,
                        itemType: coupon.offerPgm
                    }
                ]
            };
        } else {
            reqBody = {
                items: [
                    {
                        clipType: 'C',
                        itemId: coupon.offerId,
                        itemType: coupon.offerPgm
                    },
                    {
                        clipType: 'L',
                        itemId: coupon.offerId,
                        itemType: coupon.offerPgm
                    }
                ]
            };
        }

        result = this._http.post(clipUrl, reqBody, httpOptions).pipe(
            map((response) => {
                console.warn('clip response', response);
                if(response && response['items']) {
                    if (response['items'][0]['status'] == 1) {
                        coupon.status = 'C';
                        coupon.deleted = false;
                        /* Local Storage implementation
                         * Clip state is global; keep both gallery caches in sync so a clip made on one
                         * surface (e.g. the offer-details drawer) isn't reverted by another surface's
                         * cache read. Each update is a no-op when the offer isn't in that cache. */
                        this.updateLocalStorage('abJ4uCoupons', true, coupon);
                        this.updateP13nLocalStorage(true, coupon);
                        this.commonService.clipEcomGalleryCoupon(coupon.offerId);

                        // update analytics data layer
                        const _coupon = {
                            "brand": coupon['instantAllocation'] ? 'welcome-offer-clip' : coupon.brand,
                            "offerType": coupon.offerPgm,
                            "offerId": coupon.offerId,
                            "offerPrice": coupon.offerPrice,
                            "carouselSection": window && window['digitalData'] && window['digitalData']['productInfo'] && window['digitalData']['productInfo'].carouselSection || ''
                        };
                        if (window && window['AB'] && window['AB']['DATALAYER']) {
                            window['AB']['DATALAYER'].clipCoupon(_coupon, analyticsData);
                        }

                    } else if (response['items'][0]['status'] == 0) {

                        $('#errorModal').modal({'show': true});
                        let strError = "200: Coupon Expired";
                        if(response['items'][0].errorCd && response['items'][0].errorMsg) {
                            strError += " " + response['items'][0].errorCd + " " + response['items'][0].errorMsg;
                        }

                        window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);

                    } else {

                        $('#errorModal').modal({'show': true});
                        let strError = "200: Coupon Clip failed - status is not either 0 or 1";
                        if(response['items'][0].errorCd && response['items'][0].errorMsg) {
                            strError += " " + response['items'][0].errorCd + " " + response['items'][0].errorMsg;
                        }

                        window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);
                    }
                } else if (response['items'][0]['status'] == 0) {

                    $('#errorModal').modal({'show': true});
                    let strError = "200: Coupon Expired";
                    if(response['items'][0].errorCd && response['items'][0].errorMsg) {
                        strError += " " + response['items'][0].errorCd + " " + response['items'][0].errorMsg;
                    }

                    window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);


                } else {

                    $('#errorModal').modal({'show': true});
                    let strError = "200: Coupon Clip failed - items is not defined ";
                    if(response['errorCd'] && response['errorMsg']) {
                        strError += " " + response['errorCd'] + " " + response['errorMsg'];
                    }

                    window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);
                }

                return response;
            }),
            catchError((err) => {
                console.error('clip error', err);
                let strError = err.status + ": Coupon Clip failed";
                if(typeof err.error == "object" && Array.isArray(err.error.errors) && err.error.errors.length > 0) {
                    strError += " " + err.error.errors[0].code + " " + err.error.errors[0].msg;
                }

                window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);

                return null;
            })
        );

        //entrance point for progressive profiling
        if(window['AB'].userInfo.profileEmail === '' || window['AB'].userInfo.profilePhone === '') {
            this.triggerProgressiveProfile(isP13nCoupon);
        }

        return result;
        
    }

    public unclipCoupon(offer: any): Observable<any> {

        const httpOptions = {headers: new HttpHeaders(this.aemService.getJ4uHttpOptions())};
        const banner = this._userInfoService.getBanner();
        let unClipUrl = this.config[this.currentEnv].baseURL.replace('{banner}', banner);
        unClipUrl += this.config[this.currentEnv].j4uAPIDetails.unclipPath;
        let result: Observable<any> = defer(() => of({}));

        const body = { items: [{ id: offer.id }] };

        result = this._http.post(unClipUrl, body, httpOptions).pipe(
            map((response) => {
                this.updateLocalStorage('abJ4uCoupons', false, offer);

                this.commonService.unclipEcomGalleryCoupon(offer.referenceId);

                const _coupon = {
                    "brand": offer.title,
                    "offerType": offer.itemType,
                    "offerId": offer.referenceId,
                    "offerPrice": offer.savingsValue
                };

                window['AB']['DATALAYER'].unClipCoupon(_coupon);
                //add 'ecoupon' flag in cookie to show shop coupon has been unclipped
                window['SWY'].ENFORCEMENTUTILS.updateReInitSite('ecoupon');

                return response;
            }),
            catchError((err) => {
                console.error('Unclip error', err);
                let strError = err.status + ": Coupon UnClip failed";
                if(typeof err.error == "object" && Array.isArray(err.error.errors) && err.error.errors.length > 0) {
                    strError += " " + err.error.errors[0].code + " " + err.error.errors[0].msg;
                }

                window['AB']['DATALAYER'].setError(offer.id.toString(), 'coupon clipping', strError);

                return null;
            })
        );
        
        return result;
    }

    private updateLocalStorage(localStorageItem: any, isClipped: boolean, coupon: any) {
        if(this.utilService.isLSCompatible() && localStorage[localStorageItem] != undefined ) {
            const couponsData = JSON.parse(localStorage[localStorageItem]);
            if (couponsData) {
                couponsData['updatedOn'] = new Date().toLocaleString();
                const objCoupons = couponsData['objCoupons'];
                if(objCoupons && objCoupons[isClipped ? coupon.offerId : coupon.referenceId] != undefined){
                    const tempCoupon = objCoupons[isClipped ? coupon.offerId : coupon.referenceId];
                    tempCoupon.status = isClipped ? 'C' : 'U';
                    tempCoupon.deleted = !isClipped;
                    /* custom code for instant allocation
                        * can be deleted once campaign is completed */
                    if (tempCoupon.instantAllocation == true && isClipped) {
                        couponsData['instantAllocOffer'] = [];
                        tempCoupon.instantAllocation = undefined;
                    } else if (tempCoupon.events.includes("Welcome Offers") && !isClipped) {
                        tempCoupon.instantAllocation = true;
                        couponsData['instantAllocOffer'] = [tempCoupon];
                    }

                }
                couponsData['arrClippedCoupons'] = isClipped ? [...couponsData['arrClippedCoupons'], coupon.offerId] : couponsData['arrClippedCoupons'].filter(id => id != coupon.referenceId);
                localStorage[localStorageItem] = JSON.stringify(couponsData);
            }
        }
    }

    private updateP13nLocalStorage(isClipped: boolean, coupon: any) {
        const key = 'p13nCoupons'
        if(this.utilService.isLSCompatible() && localStorage[key] != undefined ) {
            const couponsData = JSON.parse(localStorage[key]);
            if (couponsData) {
                const dealsInfo = couponsData['dealsInfo'];
                const updatedCoupon = dealsInfo && dealsInfo.find((localCoupon) => localCoupon.offerId === coupon.offerId);
                /* The offer may not belong to this cache at all - leave it untouched, otherwise
                 * arrClippedCoupons would gain ids missing from dealsInfo and skew the
                 * "fetch additional offers" threshold in getP13nData. */
                if (!updatedCoupon) {
                    return;
                }
                couponsData['updatedOn'] = new Date().toLocaleString();
                updatedCoupon.status = isClipped ? 'C' : 'U';
                updatedCoupon.deleted = !isClipped;

                const arrClippedCoupons = couponsData['arrClippedCoupons'] || [];
                couponsData['arrClippedCoupons'] = isClipped ? [...arrClippedCoupons, coupon.offerId] : arrClippedCoupons.filter(id => id != coupon.referenceId);
                localStorage[key] = JSON.stringify(couponsData);
            }
        } 
    }

    public broadcastCompanionGalleryOfferPOST(data:CouponModel[] ):void {
        this._companionGalleryOfferPOST.next(data);
    }

    /**
    * convert JSON from AEM eg. {Emilie Thanksgiving},{Weekly Ad Coupons}
    * into String array ["emilie thanksgiving", "weekly ad coupons"] for easier comparison
    */
    public convertJsonArrayToStringArray(_jsonArray: string): string[]  {
         const _resultArray:string[] = _jsonArray.split(/[{}]/);
         const _filtered= _resultArray.map(v => v.toLowerCase()).filter(n => n).filter(item => item !== ",")
        return _filtered;
    }

    /**
    * determine the correct icon to display base on freshPass, UDC, enableDefault or default
    *        let that = {
    *            "iconImage":                           when '', will default to DEFAULT image which is SVG in HTML
    *                                                   when "LastBeforeDefaultIconImage", will display image configured in /etc/design
    *                                                   when "FreshPassIconImage", will display freshpass image
    *            "logoSVGCouponItemImageEnable" :       flag to replace DEFAULT image
    *            "logoSVGCouponItemImage" :             image to replace DEFAULT image
    *            "freshPassEnable":                     flag to enable FreshPass image (Freshpass image is base on events)
    *            "freshPassCouponEventListener":        event which Freshpass listens to
    *            "events" :                             coupon events which is use to match Freshpass event
    *            "UDCDealsEnable":                      Flag to enable UDC
    *        };
    */
    public findIconToDisplay(that) {
        if (!that.iconImage) {
            that.iconImage = '';
        }
        if (that.logoSVGCouponItemImageEnable) {
            that.iconImage = "LastBeforeDefaultIconImage";
        }
        if (that.freshPassEnable && that.freshPassCouponEventListener && that.freshPassCouponEventListener.length > 0) {
                if (Array.isArray(that.events)) {
                    let freshPassExist = false;
                    for (const i in that.events) {
                        if ((that.freshPassCouponEventListener.map(e=> e.toLowerCase())).indexOf(that.events[i].toLowerCase()) !== -1) {
                            freshPassExist = true;
                        } else {
                            freshPassExist = false;
                            break;
                        }
                    }
                    if (freshPassExist) {
                        that.iconImage = "FreshPassIconImage"; //only display freshpass logo if ALL events are freshpass event
                    }
                }
        }
        if (that.UDCDealsEnable) { //this will override freshpass event
            that.iconImage = "UDCDealIconImage";
        }
    }

    /** PROGRESSIVE PROFILING 
     * user gets sent to this checkpoint if they're missing email
     * func calls mylist - if mylist is empty then progressive profiling flow will initiate
     * TODO: Add flow for when user is missing phone number when UCA API is ready
     */
    public triggerProgressiveProfile(isP13nCoupon?: boolean) {
        //check coupons since email is empty
        let coupons;
        const key = isP13nCoupon ? 'p13nCoupons' : 'abJ4uCoupons';
        try {
            coupons = JSON.parse(localStorage.getItem ( key ));
        } catch(e) {
            coupons = "";
        }

        // check if behaviorCoupons is available in LS
        if (coupons != null && coupons != '') {
            // check if abJ4uCoupons is available in LS
            if (coupons.arrClippedCoupons && coupons.arrClippedCoupons.length == 0) {
                this.showProgressiveProfile();
            }
        } else {
            //if clipped coupons not available in LS , make myList call
            this.getMyListData()
            .subscribe(data => {
                if (data) {
                    const clippedCoupons = data.shoppingLists && data.shoppingLists[0] && data.shoppingLists[0].items ? data.shoppingLists[0].items : "";
                    if (clippedCoupons == "") {
                        this.showProgressiveProfile();
                    }
                } 
            }, err => {
                console.log ( err );
            });
        }
    }

    /**
     * For Progressive Profiling Flow:
     * @returns data from my list API
     */
    public getMyListData(): Observable<any> {
        const currentTimeInMilliseconds = Date.now();
        const httpOptions = { headers: new HttpHeaders(this.aemService.getJ4uHttpOptions11()) };
        return this._http.get(window['AB'].myListPath + '?storeId=' + window['AB'].userInfo.j4u.storeId + '&_ws_as_ff=y&' + currentTimeInMilliseconds, httpOptions);
    }

    /**
     * For Progressive Profiling Flow:
     * shows the modal
     */
    public showProgressiveProfile() {
        $('#modalProfile').modal({ 'show': true });
        window['AB'].DIVISIONAL.modalTrapKeyboard('#modalProfile');
        setTimeout(function () {
            document.getElementById('ppUsername').focus();
        }, 500);
        if (window['AB'].DATALAYER) {
            const analyticsFlow = window['AB'].userInfo.profilePhone === '' ? 'enter-mobile' : 'enter-email';
            window['AB'].DATALAYER.progressiveProfilingTracking({subSection1: 'progressive-profile', subSection2: analyticsFlow, topNav: 'cta:clip-coupon'});
        }
    }

    public isRewardCoupon(coupon: any) {
        return ((coupon.offerProgramType && this.rewardProtoTypes.includes(coupon.offerProgramType)) || (coupon.offerProtoType && this.rewardProtoTypes.includes(coupon.offerProtoType)));
    }


    public getLogoList() {
        let url: string  = `${window.location.origin}/content/experience-fragments/xf/foru/logos/master.caas.json`;
        if (window.location.href.includes('local')) {
            url = `https://www-qa1.${window['AB']['userInfo']['banner']}.com/content/experience-fragments/xf/foru/logos/master.caas.json`;
        }
        return this._http.get(url).pipe(
            map ((data: any) => {
                const logos = data.root.responsivegrid.j4u_logos;
                const logoProps = {
                    'FreshPassIconImage' : {
                      logo: window.location.href.includes('local') ? `https://www-qa1.${window['AB']['userInfo']['banner']}.com/${logos.freshPassLogo}` : logos.freshPassLogo,
                      altText: 'Just 4 U Freshpass logo'
                    },
                    'LastBeforeDefaultIconImage' : {
                      logo: window.location.href.includes('local') ? `https://www-qa1.${window['AB']['userInfo']['banner']}.com/${logos.forULogo}` : logos.forULogo,
                      altText: 'For U logo'
                    },
                    'RewardsIconImage': {
                      logo: window.location.href.includes('local') ? `https://www-qa1.${window['AB']['userInfo']['banner']}.com/${logos.rewardsLogo}` : logos.rewardsLogo,
                      altText: 'Rewards logo'
                    },
                    'defaultIconImage': {
                      logo: window.location.href.includes('local') ? `https://www-qa1.${window['AB']['userInfo']['banner']}.com/${logos.forULogo}` : logos.forULogo,
                      altText: 'Just 4 U logo'
                    }
                  }
                return logoProps;
            }),
          catchError(this.handleError)
        );
    }
  
    private handleError(errorResponse: HttpErrorResponse) {
      if (
          !(errorResponse.error instanceof ErrorEvent) &&
          errorResponse.error
      ) {
          return throwError("error");
      }
    }
}
